<template>
  <div class="aftersales_main1">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="退货退款" name="first"></el-tab-pane>
      <!--      <el-tab-pane label="换货" name="second"></el-tab-pane>-->
    </el-tabs>
    <!--    <el-card shadow="never">-->
    <!--      <div style="display: flex;justify-content: space-between; align-items: center;width: 100%;">-->
    <!--        <div style="display: inline-block;">-->
    <!--          <el-badge value="14" class="item">-->
    <!--            <el-button @click="changeIndex(1)" :class="{'selected1': selectedIndex ===1}" size="small">待处理</el-button>-->
    <!--          </el-badge>-->
    <!--          <el-badge value="30" class="item">-->
    <!--            <el-button @click="changeIndex(2)" :class="{'selected1': selectedIndex ===2}" size="small">退款进行中</el-button>-->
    <!--          </el-badge>-->
    <!--          <el-badge value="14" class="item">-->
    <!--            <el-button @click="changeIndex(3)" :class="{'selected1': selectedIndex ===3}" size="small">已完成</el-button>-->
    <!--          </el-badge>-->
    <!--          <el-badge value="30" class="item">-->
    <!--            <el-button @click="changeIndex(4)" :class="{'selected1': selectedIndex ===4}" size="small">已拒绝</el-button>-->
    <!--          </el-badge>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </el-card>-->
    <div class="info-box">

      <el-form :inline="true" :model="form">
        <el-form-item label="售后搜索：">
          <el-input style="width: 250px;" clearable v-model="form.keyWord" placeholder="请输入订单编号/售后编号/手机号/商品ID"></el-input>
        </el-form-item>
        <el-form-item label="类型：">
          <el-select v-model="form.type" placeholder="请选择">
            <el-option :value="4" label="全部"></el-option>
            <el-option :value="1" label="退款"></el-option>
            <el-option :value="2" label="退货"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否超过24小时未处理：">
          <el-select clearable v-model="form.isNotAuditFor24">
            <el-option :value="true" label="是"></el-option>
            <el-option :value="false" label="否"></el-option>
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="处理状态：">-->
        <!--          <el-select v-model="form.handleStatus">-->
        <!--            <el-option :value="-1" label="全部"></el-option>-->
        <!--            <el-option :value="0" label="待处理"></el-option>-->
        <!--            <el-option :value="1" label="进行中"></el-option>-->
        <!--            <el-option :value="2" label="已完成"></el-option>-->
        <!--            <el-option :value="3" label="已取消"></el-option>-->
        <!--            <el-option :value="4" label="已拒绝"></el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="类型：">-->
        <!--          <el-select v-model="form.Type" placeholder="请选择">-->
        <!--            <el-option :value="4" label="全部"></el-option>-->
        <!--            <el-option :value="1" label="退款"></el-option>-->
        <!--            <el-option :value="2" label="退货"></el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="采销状态：">-->
        <!--          <el-select v-model="form.PurchaseSaleStatus">-->
        <!--            <el-option :value="-1" label="全部"></el-option>-->
        <!--            <el-option :value="0" label="待审核"></el-option>-->
        <!--            <el-option :value="1" label="通过待提交"></el-option>-->
        <!--            <el-option :value="2" label="通过"></el-option>-->
        <!--            <el-option :value="3" label="拒绝"></el-option>-->
        <!--            <el-option :value="4" label="通过已提交"></el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="订单号：">-->
        <!--          <el-input v-model="form.OrderNo" placeholder="请输入内容"></el-input>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="申请人：">-->
        <!--          <el-input v-model="form.ApplyUser" placeholder="请输入内容"></el-input>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="处理状态：">-->
        <!--          <el-select v-model="form.HandleStatus">-->
        <!--            <el-option :value="-1" label="全部"></el-option>-->
        <!--            <el-option :value="0" label="待处理"></el-option>-->
        <!--            <el-option :value="1" label="进行中"></el-option>-->
        <!--            <el-option :value="2" label="已完成"></el-option>-->
        <!--            <el-option :value="3" label="已取消"></el-option>-->
        <!--            <el-option :value="4" label="已拒绝"></el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="财务状态：">-->
        <!--          <el-select v-model="form.FinanceStatus">-->
        <!--            <el-option :value="-1" label="全部"></el-option>-->
        <!--            <el-option :value="0" label="待审核"></el-option>-->
        <!--            <el-option :value="1" label="已通过"></el-option>-->
        <!--            <el-option :value="2" label="已拒绝"></el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="客户退款状态：">-->
        <!--          <el-select v-model="form.RefundStatus">-->
        <!--            <el-option :value="-1" label="全部"></el-option>-->
        <!--            <el-option :value="0" label="未退款"></el-option>-->
        <!--            <el-option :value="1" label="已退款"></el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="供应商回款状态：">-->
        <!--          <el-select v-model="form.SupReturnPayStatus">-->
        <!--            <el-option :value="-1" label="全部"></el-option>-->
        <!--            <el-option :value="0" label="未处理"></el-option>-->
        <!--            <el-option :value="1" label="余额抵扣"></el-option>-->
        <!--            <el-option :value="2" label="打款退款"></el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="时间：">-->
        <!--          <el-select v-model="form.orderStatus">-->
        <!--            <el-option :value="-1" label="申请时间"></el-option>-->
        <!--            <el-option :value="10" label="采销审核时间"></el-option>-->
        <!--            <el-option :value="20" label="资料提交时间"></el-option>-->
        <!--            <el-option :value="20" label="财务审核时间"></el-option>-->
        <!--            <el-option :value="20" label="回款确认时间"></el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <el-form-item>
          <el-date-picker v-model="valueTime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">筛选</el-button>
          <el-button @click="onEmpty">清空</el-button>
        </el-form-item>
      </el-form>
      <!--      <div class="tool_box">-->
      <!--        <toolbar :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>-->
      <!--      </div>-->
      <el-card shadow="never">
        <!--        <div class="tab-box">-->
        <!--        <span-->
        <!--            class="tab-item"-->
        <!--            @click="handOrderStatus(tab,index)"-->
        <!--        >你好-->
        <!--          <span class="tag">5</span>-->
        <!--        </span>-->
        <!--        </div>-->
        <div class="tab-box">
          <span class="tab-item" :class="{ activeTab: orderStatus == 0 }" @click="handOrderStatus(0)">待处理
            <span class="tag">{{ waitHandle }}</span>
          </span>
          <span class="tab-item" :class="{ activeTab: orderStatus == 2 }" @click="handOrderStatus(2)">已通过
            <span class="tag">{{ alreadyHandle }}</span>
          </span>
          <span class="tab-item" :class="{ activeTab: orderStatus == 4 }" @click="handOrderStatus(4)">已拒绝
            <span class="tag">{{ alreadyRefuse }}</span>
          </span>
          <span class="tab-item" :class="{ activeTab: orderStatusIsTrue == true }"
            @click="handOrderStatusTrue(true)">超时未处理
            <span class="tag">{{ overTime }}</span>
          </span>
        </div>
      </el-card>
      <br />
      <el-card>
        <el-table :data="orderList" border style="width: 100%" v-loading="loading" element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
          :cell-class-name="setCellStyle" :row-class-name="tableRowClassName" @row-click="rowClick">
          <el-table-column label="订单号" width="180">
            <template slot-scope="scope">
              订单号:{{ scope.row.thirdOrderId }}<br />
              外部单号:{{ scope.row.childOrderNo }}
            </template>
          </el-table-column>
          <el-table-column label="最近一次更新进度" width="300">
            <template slot-scope="scope">
              <h4>{{ scope.row.afterSaleOrderNote && scope.row.afterSaleOrderNote.note }}</h4>
              <div>
                <div style="display: inline-block;margin-right:5px;"
                  v-for="item in scope.row.afterSaleOrderNote && scope.row.afterSaleOrderNote.pics">
                  <img :src="item" style="width:100px;height: 100px" />
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="申请时间" width="180">
          </el-table-column>
          <!--          <el-table-column-->
          <!--              prop="address"-->
          <!--              label="售后单号">-->
          <!--          </el-table-column>-->
          <el-table-column width="200" label="商品信息">
            <template slot-scope="scoped">
              商品名称:{{ scoped.row.skuName }}<br />
              品牌:{{ scoped.row.brandName }}<br />
              品类:{{ scoped.row.skuTypeName }}<br />
              型号:{{ scoped.row.modelCode }}<br />
              规格:{{ scoped.row.skuSpecs }}<br />
              规格属性:{{ scoped.row.skuSpecsExt }}<br />
            </template>
          </el-table-column>
          <el-table-column width="250" label="下单信息">
            <template slot-scope="scoped">
              联系人:{{ scoped.row.receiverName }}
              联系电话:{{ scoped.row.receiverPhone }}
              收货地址:{{ scoped.row.receiverProvinceName }}{{ scoped.row.receiverCityName }}{{
                scoped.row.receiverDistrictName }}{{ scoped.row.receiverAddress }}
            </template>
          </el-table-column>
          <el-table-column width="150" label="金额">
            <template slot-scope="scoped">
              实收:{{ scoped.row.billAmount }}<br />
              退款:{{ scoped.row.billRefundAmount }}<br />
              实际退款:{{ scoped.row.billActualRefundAmount }}
              <!-- 实收:{{scoped.row.amount}}<br />
              退款:{{scoped.row.refundAmount}}<br />
              实际退款:{{scoped.row.actualRefundAmount}} -->
            </template>
          </el-table-column>
          <el-table-column label="数量">
            <template slot-scope="scoped">
              下单:{{ scoped.row.skuNumber }}
              退/换货:{{ scoped.row.applySkuNumber }}
            </template>
          </el-table-column>
          <el-table-column label="售后类型">
            <template slot-scope="scoped">
              {{ scoped.row.type == 1 ? '退款' : scoped.row.type == 2 ? '退货' : '' }}
            </template>
          </el-table-column>
          <el-table-column label="发货状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 10">待支付</span>
              <span v-if="scope.row.status == 20">备货中</span>
              <span v-if="scope.row.status == 30">待收货</span>
              <span v-if="scope.row.status == 40">已收货</span>
              <span v-if="scope.row.status == 50">已完成</span>
              <span v-if="scope.row.status == 60">已取消</span>
              <span v-if="scope.row.status == 70">已关闭</span>
            </template>
          </el-table-column>
          <el-table-column prop="reason" label="售后原因">
          </el-table-column>
          <el-table-column center prop="attachContent" width="250" label="补充说明">
            <!--            <template slot-scope="scope">-->
            <!--              <div>-->
            <!--                <p>-->
            <!--                  {{scope}}-->
            <!--                </p>-->
            <!--              </div>-->
            <!--              <div v-for="(item, index) in scope.row.intro">-->
            <!--                <img style="width: 200px;height:200px;" :src="item" />-->
            <!--              </div>-->
            <!--            </template>-->
          </el-table-column>
          <el-table-column width="250" label="凭证">
            <template slot-scope="scope">
              <div v-for="(item, index) in scope.row.intro">
                <img style="width: 200px;height:200px;" :src="item" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="businessStatusName" label="售后状态">
            <!--            <template slot-scope="scope">-->
            <!--              <span v-if="scope.row.handleStatus == 0">待处理</span>-->
            <!--              <span v-if="scope.row.handleStatus == 1">进行中</span>-->
            <!--              <span v-if="scope.row.handleStatus == 2">已完成</span>-->
            <!--              <span v-if="scope.row.handleStatus == 3">已取消</span>-->
            <!--              <span v-if="scope.row.handleStatus == 4">已拒绝</span>-->
            <!--            </template>-->
          </el-table-column>
          <el-table-column prop="businessRejectReason" label="拒绝原因">
          </el-table-column>
          <!--          <el-table-column align="center" width="90" fixed="left">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-button type="primary" size="mini" @click="handleShowRefundInfo(scope.row)">查看-->
          <!--              </el-button>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column label="类型" align="center" width="120">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-tag type="info" v-if="scope.row.Type == 1">退款</el-tag>-->
          <!--              <el-tag type="danger" v-else-if="scope.row.Type == 2">退货</el-tag>-->
          <!--              <el-tag type="success" v-else-if="scope.row.Type == 3">换货</el-tag>-->
          <!--              <p v-if="scope.row.platformAfterSaleOrder">-->
          <!--                <span v-if="scope.row.platformAfterSaleOrder.PlatformType == 1">星链售后状态：</span>-->
          <!--                <span v-if="scope.row.platformAfterSaleOrder.PlatformType == 2">京东开普勒售后状态：</span>-->
          <!--                <span v-if="scope.row.platformAfterSaleOrder.PlatformType == 3">京东京东电售后状态：</span>-->
          <!--                <el-tag type="success" v-if="scope.row.platformAfterSaleOrder.Status == 1">申请中</el-tag>-->
          <!--                <el-tag type="success" v-else-if="scope.row.platformAfterSaleOrder.Status == 2">审核通过-->
          <!--                </el-tag>-->
          <!--                <el-tag type="success" v-else-if="scope.row.platformAfterSaleOrder.Status == 3">已发货-->
          <!--                </el-tag>-->
          <!--                <el-tag type="success" v-else-if="scope.row.platformAfterSaleOrder.Status == 4">已退款-->
          <!--                </el-tag>-->
          <!--                <el-tag type="success" v-else-if="scope.row.platformAfterSaleOrder.Status == 5">已拒绝-->
          <!--                </el-tag>-->
          <!--                <el-tag type="success" v-else-if="scope.row.platformAfterSaleOrder.Status == 6">已取消-->
          <!--                </el-tag>-->
          <!--                <el-tag type="success" v-else-if="scope.row.platformAfterSaleOrder.Status == 7">已完成-->
          <!--                </el-tag>-->
          <!--              </p>-->
          <!--              <el-tooltip v-if="scope.row.ResponsibilityTagType || scope.row.ResponsibilityTag" placement="bottom"-->
          <!--                          effect="light">-->
          <!--                <span slot="content">-->
          <!--                  <span>{{ scope.row.ResponsibilityTagType | tagTypeName }}</span>-->
          <!--                  <span v-if="scope.row.ResponsibilityTagType && scope.row.ResponsibilityTag">,</span>-->
          <!--                  <span>{{ scope.row.ResponsibilityTag }}</span>-->
          <!--                </span>-->
          <!--                <el-tag>定责标识</el-tag>-->
          <!--              </el-tooltip>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column label="处理状态" align="center" width="100">-->
          <!--            <template slot-scope="scope">-->
          <!--              <div class="logStyle" @click="handleShowRefundInfo(scope.row)">-->
          <!--                <span v-if="scope.row.HandleStatus == 0">待处理</span>-->
          <!--                <span v-else-if="scope.row.HandleStatus == 1">进行中</span>-->
          <!--                <span v-else-if="scope.row.HandleStatus == 2">已完成</span>-->
          <!--                <span v-else-if="scope.row.HandleStatus == 3">已取消</span>-->
          <!--                <span v-else-if="scope.row.HandleStatus == 4">已拒绝</span>-->
          <!--                <span v-else>/</span>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column label="审批状态" align="center" width="300">-->
          <!--            <template slot-scope="scope">-->
          <!--              <approval-process :list="scope.row.deptAudits"></approval-process>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column label="订单信息" align="center" width="400">-->
          <!--            <template slot-scope="scope">-->
          <!--              <div style="text-align: left">-->
          <!--                <p style="color:red;" v-if="scope.row.isIssueInvoice">已开票</p>-->
          <!--                <p>-->
          <!--                  订单号：{{ scope.row.ChildOrderNo }}-->
          <!--                  <el-tag size="mini" type="danger" v-if="scope.row.IsBlockedOrder">黑名单</el-tag>-->
          <!--                </p>-->
          <!--                <p>订单状态：{{ scope.row.Status | orderStatusName }}</p>-->
          <!--                <p>商品名称：{{ scope.row.SkuName }}</p>-->
          <!--                <p>-->
          <!--                  会员账号：{{ scope.row.CustomerUserName }}-->
          <!--                  <el-tag size="mini" type="danger" v-if="scope.row.IsBlockedBusinesses">黑名单</el-tag>-->
          <!--                </p>-->
          <!--                <p>名称：{{ scope.row.CustomerNickName }}</p>-->
          <!--&lt;!&ndash;                <template v-if="scope.row.LCCWInfo.IsHaveLockRecord">&ndash;&gt;-->
          <!--&lt;!&ndash;                  <el-button @click="orderDetail(scope.row.LCCWInfo.LockMainOrderId)" type="text">锁货订单号：{{&ndash;&gt;-->
          <!--&lt;!&ndash;                      scope.row.LCCWInfo.LockMainOrderNo }}</el-button>&ndash;&gt;-->
          <!--&lt;!&ndash;                  <p>锁货订单支付方式：{{ scope.row.LCCWInfo.LockPayTypeStr }}</p>&ndash;&gt;-->
          <!--&lt;!&ndash;                  <p>锁货订单交易流水号：{{ scope.row.LCCWInfo.LockPayTradeNo }}</p>&ndash;&gt;-->
          <!--&lt;!&ndash;                </template>&ndash;&gt;-->
          <!--                &lt;!&ndash; 扣除金豆 &ndash;&gt;-->
          <!--                <template v-if="scope.row.ReturnMemberRebate > 0">-->
          <!--                  <div v-if="scope.row.IsDeductReturnMemberRebate">-->
          <!--                    已扣除商品返豆：-{{ scope.row.DeductMemberRebate }}豆，金额：-￥{{ scope.row.DeductRefundAmount }}-->
          <!--                  </div>-->
          <!--                  <div style="display: flex;align-items:center;" v-else>-->
          <!--                    <p style="margin-right:7px;">该订单已返豆需扣除盟友豆{{ scope.row.DeductMemberRebate }}豆</p>-->
          <!--                    <el-button type="primary" size="mini" @click="handleTakeoffBean(scope.row)"-->
          <!--                               v-if="showDeductMemberRebateBtn">确认扣除</el-button>-->
          <!--                  </div>-->
          <!--                </template>-->
          <!--                <div style="display: flex" v-if="scope.row.EnvelopeList[0]">-->
          <!--                  <div>红包情况：</div>-->
          <!--                  <div>-->
          <!--                    <p v-for="(envelog, envelogid) in scope.row.EnvelopeList" :key="envelogid">-->
          <!--                      <span>￥{{ envelog.Amount }}</span>-->
          <!--                      <span>{{-->
          <!--                          envelog.Status == 1-->
          <!--                              ? "可使用"-->
          <!--                              : envelog.Status == 2-->
          <!--                                  ? "已使用"-->
          <!--                                  : envelog.Status == 3-->
          <!--                                      ? "已过期"-->
          <!--                                      : "冻结中"-->
          <!--                        }}</span>-->
          <!--                    </p>-->
          <!--                  </div>-->
          <!--                  <div style="margin-left: 20px">-->
          <!--                    <el-button size="mini" type="success" v-if="!scope.row.IsChangeEnvelopeMoney &&-->
          <!--                      scope.row.IsShowEnvelopeBtn-->
          <!--                      " @click="envelopeRefund(scope.row)">红包修改-->
          <!--                    </el-button>-->
          <!--                    <el-tag size="mini" type="danger" v-if="scope.row.IsChangeEnvelopeMoney">已修改-->
          <!--                    </el-tag>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--                <div style="display: flex" v-if="scope.row.CouponList && scope.row.CouponList.length > 0">-->
          <!--                  <div>优惠券情况：</div>-->
          <!--                  <div>-->
          <!--                    <p v-for="(coupon, couponid) in scope.row.CouponList" :key="couponid">-->
          <!--                      <span>￥{{ coupon.Amount }}</span>-->
          <!--                      <span>{{-->
          <!--                          coupon.Status == 1-->
          <!--                              ? "可使用"-->
          <!--                              : coupon.Status == 2-->
          <!--                                  ? "已使用"-->
          <!--                                  : "已过期"-->
          <!--                        }}</span>-->
          <!--                    </p>-->
          <!--                  </div>-->
          <!--                  <div style="margin-left: 20px">-->
          <!--                    <el-button size="mini" type="success" v-if="!scope.row.IsChangeCouponMoney &&-->
          <!--                      scope.row.IsShowCouponBtn-->
          <!--                      " @click="couponRefund(scope.row)">优惠券修改-->
          <!--                    </el-button>-->
          <!--                    <el-tag size="mini" type="danger" v-if="scope.row.IsChangeCouponMoney">已修改-->
          <!--                    </el-tag>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--                <div style="display: flex" v-if="scope.row.MemberRebateAmount > 0">-->
          <!--                  <div>-->
          <!--                    盟友金<span style="color: #f40000">¥{{ scope.row.MemberRebateAmount }}</span>已解冻-->
          <!--                  </div>-->
          <!--                  <div style="margin-left: 20px">-->
          <!--                    <el-button size="mini" type="success" v-if="scope.row.AllowDeductMemberRebateAmount &&-->
          <!--                      allowDeductMemberRebateAmount-->
          <!--                      " @click="deductMemberRebateAmount(scope.row)">扣除-->
          <!--                    </el-button>-->
          <!--                    <el-tag size="mini" type="danger" v-if="scope.row.IsDeductMemberRebateAmount">-->
          <!--                      已扣除-->
          <!--                    </el-tag>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--                <div v-if="scope.row.IsGroupBookingOrder">-->
          <!--                  <span style="margin-right:10px;">定金情况：已支付¥{{ scope.row.GroupBookingEarnestMoney }}</span>-->
          <!--                  <el-button size="mini" type="text" v-if="scope.row.IsDeductGroupBookingEarnestMoney">已扣定金</el-button>-->
          <!--                  <template v-else>-->
          <!--                    <el-button size="mini" type="primary" v-if="canRefund" @click="groupRefund(scope.row)">扣定金-->
          <!--                    </el-button>-->
          <!--                  </template>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column label="采购供应商" prop="purchaseSupName" align="center" width="300"></el-table-column>-->
          <!--          <el-table-column label="申请数量" prop="applySkuNumber" align="center" width="100"></el-table-column>-->
          <!--          <el-table-column label="退款金额" align="center" width="120">-->
          <!--            <template slot-scope="scope">-->
          <!--              <div style="text-align: left">-->
          <!--                <p>-->
          <!--                  {{ scope.row.refundAmount }}-->
          <!--                </p>-->
          <!--                <p v-if="scope.row.orderRebateInfo">-->
          <!--                  &lt;!&ndash; 待打款 &ndash;&gt;-->
          <!--                  <span v-if="scope.row.orderRebateInfo.Status == 1">-->
          <!--                    ( 返-->
          <!--                    <el-tag effect="plain" size="mini" type="danger">待打款</el-tag>-->
          <!--                    )-->
          <!--                  </span>-->
          <!--                  &lt;!&ndash; 已打款 &ndash;&gt;-->
          <!--                  <span v-if="scope.row.orderRebateInfo.Status == 2">-->
          <!--                    ( 返 ￥{{ scope.row.orderRebateInfo.Amount }}-->
          <!--                    <el-tag effect="plain" size="mini">已打款</el-tag>-->
          <!--                    )-->
          <!--                  </span>-->
          <!--                </p>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column label="客户经理备注" prop="accountManagerRemark" align="center" width="100"></el-table-column>-->
          <!--          <el-table-column label="客户退款状态" align="center" width="140">-->
          <!--            <template slot-scope="scope">-->
          <!--              <span v-if="scope.row.refundStatus == 0 && scope.row.Type !== 3">未退款</span>-->
          <!--              <span v-else-if="scope.row.refundStatus == 1 && scope.row.Type !== 3">{{ scope.row.RefundWayStr }}</span>-->
          <!--              &lt;!&ndash; <span v-else-if="scope.row.RefundStatus == 2 && scope.row.Type !== 3">{{ scope.row.RefundWayStr }}</span> &ndash;&gt;-->
          <!--              <span v-else>/</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column label="实际退款金额" align="center" prop="actualRefundAmount" width="140"></el-table-column>-->
          <!--          <el-table-column label="运维备注" align="center" width="240">-->
          <!--            <template slot-scope="scope">-->
          <!--              <div v-if="scope.row.businessRemark">-->
          <!--                <span style="color: #f40000">{{-->
          <!--                    scope.row.businessRemark-->
          <!--                  }}</span>-->
          <!--              </div>-->
          <!--              <div v-if="scope.row.picInfoList[0]">-->
          <!--                <img class="pic-info" v-for="(img, index) in scope.row.PicInfoList" :key="index" :src="img"-->
          <!--                     @click="handleBigImg(img)" />-->
          <!--              </div>-->
          <!--              <span v-else>/</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column label="提交资料时效" align="center" width="121">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-table border :data="scope.row.supList" :show-header="false">-->
          <!--                <el-table-column label="提交资料时效" align="center" width="120">-->
          <!--                  <template slot-scope="scope2">-->
          <!--                    <span v-if="scope2.row.IsNeedSubmitData && scope2.row.IsDataSubmit-->
          <!--                      ">{{ scope2.row.SubmitTimespan }} 分钟</span>-->
          <!--                    <span v-else>/</span>-->
          <!--                  </template>-->
          <!--                </el-table-column>-->
          <!--                <el-table-column label="采购供应商" prop="supName" align="center" width="200"></el-table-column>-->
          <!--                <el-table-column label="资料提交状态" align="center" width="120">-->
          <!--                  <template slot-scope="scope2">-->
          <!--                    <span v-if="!scope2.row.IsDataSubmit">待提交</span>-->
          <!--                    <span v-else-if="scope2.row.IsDataSubmit">已提交</span>-->
          <!--                    <span v-else>/</span>-->
          <!--                  </template>-->
          <!--                </el-table-column>-->
          <!--                <el-table-column label="供应商回款状态" align="center" width="120">-->
          <!--                  <template slot-scope="scope2">-->
          <!--                    <span v-if="!scope2.row.IsSupReturnPay">待处理</span>-->
          <!--                    <span v-else-if="scope2.row.IsSupReturnPay">已收款</span>-->
          <!--                    <span v-else>/</span>-->
          <!--                  </template>-->
          <!--                </el-table-column>-->
          <!--                <el-table-column label="运费" prop="Freight" align="center" width="120"></el-table-column>-->
          <!--                <el-table-column label="承担方" align="center" width="140">-->
          <!--                  <template slot-scope="scope2">-->
          <!--                    <span v-if="scope2.row.BearFreight == 1">营客通承担</span>-->
          <!--                    <span v-else-if="scope2.row.BearFreight == 2">客户承担</span>-->
          <!--                    <span v-else-if="scope2.row.BearFreight == 3">供应商承担</span>-->
          <!--                    <span v-else-if="scope2.row.BearFreight == 4">无需运费</span>-->
          <!--                    <span v-else>/</span>-->
          <!--                  </template>-->
          <!--                </el-table-column>-->
          <!--                <el-table-column label="资料提交" align="center" width="100">-->
          <!--                  <template slot-scope="scope2">-->
          <!--                    <el-button type="primary" size="mini" v-if="scope2.row.IsNeedSubmitData && !scope2.row.IsDataSubmit-->
          <!--                      " @click="openInfoDialog(scope2.row)">提交资料-->
          <!--                    </el-button>-->
          <!--                    <span v-else>/</span>-->
          <!--                  </template>-->
          <!--                </el-table-column>-->
          <!--              </el-table>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column label="采购供应商" align="center" width="201"></el-table-column>-->
          <!--          <el-table-column label="资料提交状态" align="center" width="120"></el-table-column>-->
          <!--          <el-table-column label="供应商回款状态" align="center" width="120"></el-table-column>-->
          <!--          <el-table-column label="运费" align="center" width="120"></el-table-column>-->
          <!--          <el-table-column label="承担方" align="center" width="140"></el-table-column>-->
          <!--          <el-table-column label="资料提交" align="center" width="100"></el-table-column>-->
          <!--          <el-table-column label="操作情况" align="center" width="300">-->
          <!--            <template slot-scope="scope">-->
          <!--              <div style="text-align: left">-->
          <!--                <p v-for="(item, index) in scope.row.TrackList" :key="index">-->
          <!--                  <span>{{ item.Description }}</span>&nbsp;&nbsp;<span>{{ item.CreateTime }}</span>&nbsp;&nbsp;<span>{{-->
          <!--                    item.OperatorName-->
          <!--                  }}</span>-->
          <!--                </p>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column label="三方售后状态" align="center" width="150">-->
          <!--            <template slot-scope="scope">-->
          <!--              <span v-if="scope.row.platformAfterSaleOrder">{{ scope.row.platformAfterSaleOrder.PlatformReturnStatusDesc-->
          <!--                }}</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column label="操作" fixed="right" align="center" width="200">
            <template slot-scope="scope">
              <el-button v-if="remarkShow" size="mini" type="success" style="margin-bottom: 10px"
                @click="showRemark(scope.row)">处理跟进</el-button>
              <el-button size="mini" type="success" style="margin-bottom: 10px" @click="handleDetail(scope.row)">详情
              </el-button>
              <el-button size="mini" type="success" style="margin-bottom: 10px" @click="handleCheckBill(scope.row)"
                v-if="isCheckBill && scope.row.isIssueInvoice">票据信息
              </el-button>
              <el-button size="mini" type="success" style="margin-bottom: 10px"
                v-if="isShowPass && scope.row.businessStatus == 0 && scope.row.status != 40"
                @click="passBtn(scope.row)">通过
              </el-button>
              <el-button size="mini" type="danger" style="margin-bottom: 10px"
                v-if="isShowRefuse && scope.row.businessStatus == 0 && scope.row.status != 40"
                @click="refuseBtn(scope.row)">拒绝
              </el-button>
              <el-button size="mini" type="primary" style="margin-bottom: 10px" v-if="isShowApproval &&
                scope.row.buditStatus == 0 &&
                scope.row.businessStatus == 1 &&
                scope.row.financeStatus == 0
                " @click="submitApproval(scope.row)">提交审批
              </el-button>
              <!--              <el-button size="mini" type="primary" style="margin-bottom: 10px" v-if="isShowCancel &&-->
              <!--                scope.row.auditStatus == 1 &&-->
              <!--                scope.row.financeStatus == 0-->
              <!--                " @click="cancelBtn(scope.row)">取消-->
              <!--              </el-button>-->
              <!--              <el-button size="mini" type="primary" style="margin-bottom: 10px" v-if="scope.row.isCanSetResponsibilityTag"-->
              <!--                         @click="setLabelBtn(scope.row)">设置定责标签-->
              <!--              </el-button>-->
              <span v-if="!scope.row.platformAfterSaleOrder">
                <el-button size="mini" type="primary" style="margin-bottom: 10px" v-if="scope.row.Type == 1 &&
                  scope.row.thiredOrderType == 6 &&
                  scope.row.businessStatus == 1
                  " @click="startlinkRefundBtn(scope.row)">星链申请退款</el-button>
                <el-button size="mini" type="primary" style="margin-bottom: 10px" v-if="scope.row.type == 2 &&
                  scope.row.thiredOrderType == 6 &&
                  scope.row.businessStatus == 1
                  " @click="startlinkReturnBtn(scope.row)">星链申请退货</el-button>
                <!-- <el-button size="mini" type="primary" style="margin-bottom:10px;" v-if="scope.row.thiredOrderType == 6 && scope.row.businessStatus == 1 && scope.row.platformAfterSaleOrder.ApplyType == 2" @click="startlinkDeliveryBtn(scope.row)">发货到星链</el-button> -->
                <el-button size="mini" type="primary" style="margin-bottom: 10px" v-if="scope.row.thiredOrderType >= 7 &&
                  scope.row.thiredOrderType <= 11 &&
                  scope.row.businessStatus == 1
                  " @click="keplerCancelBtn(scope.row)">开普勒售后</el-button>
                <el-button size="mini" type="primary" style="margin-bottom: 10px"
                  v-if="scope.row.thiredOrderType == 21 && scope.row.businessStatus == 1 && isAuxAftersale"
                  @click="auxAftersaleBtn(scope.row)">奥克斯售后</el-button>
                <el-button size="mini" type="primary" style="margin-bottom: 10px" v-if="scope.row.thiredOrderType == 1 &&
                  scope.row.isJDVopCanApplyAfs &&
                  scope.row.businessStatus == 1
                  " @click="keplerCancelBtn(scope.row)">慧采售后</el-button>
              </span>
              <el-button size="mini" type="primary" style="margin-bottom: 10px"
                v-if="scope.row.thiredOrderType == 23 && scope.row.businessStatus == 1 && isSuningAftersale"
                @click="suningAftersaleBtn(scope.row)">苏宁有货售后</el-button>
              <span v-if="scope.row.platformAfterSaleOrder">
                <el-button size="mini" type="primary" style="margin-bottom: 10px" v-if="scope.row.thiredOrderType == 6 &&
                  scope.row.businessStatus == 1 &&
                  scope.row.platformAfterSaleOrder.Status > 3
                  " @click="startlinkCancelBtn(scope.row)">取消星链售后</el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"
          @current-change="handleCurrentChange" style="float: right"></el-pagination>
      </el-card>
    </div>
    <!-- 通过 -->
    <el-dialog title="退款/退货" v-if="refundVisible" :visible.sync="refundVisible" :close-on-click-modal="false">
      <div>
        <div class="btm" v-if="isPresell">
          <span>是否扣除预售商品定金：</span>
          <el-radio-group v-model="isDeductDepositAmount">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </div>
        <div v-if="showUnPurchaseNumber && afterSaleOrderSup[0]">
          <!--          <div class="btm">该订单包含多供应商，请选择对应退货的渠道：</div>-->
          <div class="btm">
            <span class="mar-r">所需退货数量：{{ applySkuNumber }}</span>
            <!--            <span>未采购数量：{{ unPurchaseNumber }}</span>-->
          </div>
          <div>
            <ul>
              <li class="item-sup" v-for="(item1, index1) in afterSaleOrderSup" :key="index1">
                <div class="item-sup-l" v-show="false">
                  <el-checkbox @change="(value) => {
                    handleSupbox(value, item1);
                  }
                    "></el-checkbox>
                </div>
                <div class="item-sup-r">
                  <div class="btm" v-show="false">
                    <span>{{ item1.buySupplierName }}</span>
                  </div>
                  <div v-for="(item2, index2) in item1.childLogistics" :key="index2">
                    <div class="btm">
                      <span class="mar-r">{{ item2.logisticsCompanyName }}
                        {{ item2.logisticsCode }}</span><span>数量：{{ item2.sendSkuNumber }}台</span>
                    </div>
                  </div>
                  <div class="btm">
                    <span>运费：</span>
                    <el-radio-group v-model="item1.bearFreight" @change="(value) => handleRadio(value, item1)">
                      <!--                      <el-radio :label="1">营客通承担</el-radio>-->
                      <el-radio :label="2">客户承担</el-radio>
                      <!--                      <el-radio :label="3">供应商承担</el-radio>-->
                      <el-radio :label="4">无需运费</el-radio>
                    </el-radio-group>
                  </div>
                  <!--                  <div class="btm" v-if="item1.bearFreight != 4">-->
                  <div class="btm" v-if="item1.bearFreight == 2">
                    <span class="mar-r">金额：<el-input size="mini" style="width: 100px" v-model="item1.freight">
                      </el-input></span>
                    <el-radio-group v-model="item1.freightOperation">
                      <el-radio :label="1">在退款金额内扣除</el-radio>
                      <!--                      <el-radio :label="2">再退款金额内增加</el-radio>-->
                      <!--                      <el-radio :label="3">无需操作</el-radio>-->
                    </el-radio-group>
                  </div>
                  <div class="btm" v-show="false">
                    <span>是否需要提交资料：</span>
                    <el-radio-group v-model="item1.isNeedSubmitData">
                      <el-radio :label="true">是</el-radio>
                      <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="btm">
                    <span class="mar-r">已发货{{ item1.sendSkuNumber }}</span>
                    <span class="mar-r">未发货{{ item1.surplusSendNumber }}</span>
                    <span class="mar-r">
                      <span class="mar-r">退货:</span>
                      <span class="mar-r">已发货
                        <el-input size="mini" style="width: 100px" v-model.number="item1.deliveredNumber"></el-input>
                      </span>
                      <span>未发货
                        <el-input size="mini" style="width: 100px" v-model.number="item1.undeliveredNumber"></el-input>
                      </span>
                    </span>
                    <!--                    <el-checkbox v-model="item1.isRePurchase">重采</el-checkbox>-->
                  </div>
                </div>
              </li>
              <li>
                <!--                <div class="btm">-->
                <!--                  <span style="vertical-align: top">备注：</span>-->
                <!--                  <el-input type="textarea" v-model="remark"></el-input>-->
                <!--                </div>-->
              </li>
            </ul>
          </div>
        </div>
        <div v-if="!afterSaleOrderSup[0]">
          <div class="btm">该订单还未发货可直接提交！</div>
          <div class="btm">
            <span style="vertical-align: top">备注：</span>
            <el-input type="textarea" v-model="remark"></el-input>
          </div>
        </div>
        <div v-if="!showUnPurchaseNumber && afterSaleOrderSup[0]">
          <div class="btm">
            该订单未采购的商品数量大于等于申请退货的数量，优先选择未采购商品进行退货！
          </div>
          <div class="btm">
            <span style="vertical-align: top">备注：</span>
            <el-input type="textarea" v-model="remark"></el-input>
          </div>
        </div>
        <div>
          <!--          <div style="margin-bottom: 20px">采购记录</div>-->
          <!--          <el-table :data="purRecList" border>-->
          <!--            <el-table-column prop="ChildOrderNo" label="子订单号" align="center" width="180"></el-table-column>-->
          <!--            <el-table-column label="状态" align="center" width="180">-->
          <!--              <template slot-scope="scope">-->
          <!--                <p>-->
          <!--                  审批状态：-->
          <!--                  <el-tag size="mini" type="warning">{{-->
          <!--                      scope.row.AuditStatusName-->
          <!--                    }}</el-tag>-->
          <!--                </p>-->
          <!--                <p>-->
          <!--                  财务处理状态：-->
          <!--                  <el-tag size="mini" type="warning">{{-->
          <!--                      scope.row.FinanceOperateStatusName-->
          <!--                    }}</el-tag>-->
          <!--                </p>-->
          <!--              </template>-->
          <!--            </el-table-column>-->
          <!--            <el-table-column label="类型" align="center">-->
          <!--              <template slot-scope="scope">-->
          <!--                <span>{{ scope.row.type == 1 ? "采购 " : "冲红" }}</span>-->
          <!--              </template>-->
          <!--            </el-table-column>-->
          <!--            <el-table-column prop="Price" label="单价" align="center"></el-table-column>-->
          <!--            <el-table-column prop="Amount" label="合计" align="center"></el-table-column>-->
          <!--            <el-table-column prop="Number" label="数量" align="center"></el-table-column>-->
          <!--            <el-table-column prop="SupplierName" label="供货商" align="center"></el-table-column>-->
          <!--            <el-table-column prop="ExternalOrderNos" label="外部订单号" align="center" width="180"></el-table-column>-->
          <!--            <el-table-column prop="Remark" label="备注" align="center"></el-table-column>-->
          <!--            <el-table-column prop="CreateTime" label="录入时间" align="center" width="180"></el-table-column>-->
          <!--          </el-table>-->
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" v-preventClick @click="submitAfter">提交</el-button>
      </div>
    </el-dialog>
    <!-- 提交资料 -->
    <el-dialog title="提交资料" width="30%" :visible.sync="dialogInfoVisible" :close-on-click-modal="false">
      <el-form label-width="140px">
        <el-form-item label-width="0px">
          <div style="display: flex; justify-content: space-around">
            <div class="img-box">
              <el-upload class="el_upload" action="#" :auto-upload="false" :show-file-list="false"
                :on-change="(value) => handleChange(value, 1)">
                <img v-if="infoForm.inspectionSheePic" :src="infoForm.inspectionSheePic" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <span class="mask" v-if="infoForm.inspectionSheePic">
                  <span @click.stop="delPic(1)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </el-upload>
              <p>检验单</p>
            </div>
            <div class="img-box">
              <el-upload class="el_upload" action="#" :auto-upload="false" :show-file-list="false"
                :on-change="(value) => handleChange(value, 2)">
                <img v-if="infoForm.supReceiptPic" :src="infoForm.supReceiptPic" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <span class="mask" v-if="infoForm.supReceiptPic">
                  <span @click.stop="delPic(2)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </el-upload>
              <p>供应商收货单（必传）</p>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="供应商退款方式：">
          <el-radio-group v-model="infoForm.supReturnPayMode">
            <el-radio :label="1">余额抵扣</el-radio>
            <el-radio :label="2">打款退款</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="外部订单号：">
          <el-input v-model="infoForm.externalOrderId"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" v-model="infoForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" v-preventClick @click="submitInfo">提交</el-button>
      </div>
    </el-dialog>
    <!-- 售后信息 -->
    <el-dialog title="售后信息" width="60%" :visible.sync="showInfoVisible" :close-on-click-modal="false">
      <div>
        <div>
          <span>退款类型：</span>
          <tag type="info" v-if="showRefundInfo.type == 1">退款</tag>
          <tag type="danger" v-else-if="showRefundInfo.type == 2">退货</tag>
          <tag type="success" v-else-if="showRefundInfo.type == 3">换货</tag>
        </div>
        <div>
          <span>处理状态：</span>
          <span v-if="showRefundInfo.HandleStatus == 0">待处理</span>
          <span v-else-if="showRefundInfo.HandleStatus == 1">进行中</span>
          <span v-else-if="showRefundInfo.HandleStatus == 2">已完成</span>
          <span v-else-if="showRefundInfo.HandleStatus == 3">已取消</span>
          <span v-else-if="showRefundInfo.HandleStatus == 4">已拒绝</span>
          <span v-else>/</span>
        </div>
        <br />
        <div>
          <span>审批状态：</span>
          <approval-process :list="showRefundInfo.deptAudits"></approval-process>
        </div>
        <br />
        <div>
          <div style="text-align: left">
            <p>订单号：{{ showRefundInfo.ChildOrderNo }}</p>
            <p>订单状态：{{ showRefundInfo.Status | orderStatusName }}</p>
            <p>商品名称：{{ showRefundInfo.SkuName }}</p>
            <p>会员账号：{{ showRefundInfo.CustomerUserName }}</p>
            <p>名称：{{ showRefundInfo.CustomerNickName }}</p>
          </div>
        </div>
        <div label="申请数量" width="100">
          <p>申请数量：{{ showRefundInfo.ApplySkuNumber }}</p>
        </div>
        <div label="退款金额">
          <p>退款金额：{{ showRefundInfo.RefundAmount }}元</p>
        </div>
        <div label="客户退款状态">
          <span>客户退款状态：</span>
          <span v-if="showRefundInfo.RefundStatus == 0 && showRefundInfo.Type !== 3">未退款</span>
          <span v-else-if="showRefundInfo.RefundStatus == 1 && showRefundInfo.Type !== 3
            ">{{ scope.row.RefundWayStr }}</span>
          <!-- <span v-else-if="
            showRefundInfo.RefundStatus == 2 && showRefundInfo.Type !== 3
          ">{{ scope.row.RefundWayStr }}</span> -->
          <span v-else>/</span>
        </div>
        <div label="实际退款金额" align="center" prop="showRefundInfo.ActualRefundAmount" width="200"></div>
        <div label="提交资料时效" align="center" width="121">
          <el-table border :data="showRefundInfo.SupList" :show-header="false">
            <el-table-column label="提交资料时效" align="center" width="120">
              <template slot-scope="scope2">
                <h6>提交资料时效</h6>
                <span v-if="scope2.row.IsNeedSubmitData && scope2.row.IsDataSubmit">{{ scope2.row.SubmitTimespan }}
                  分钟</span>
                <span v-else>/</span>
              </template>
            </el-table-column>
            <el-table-column label="采购供应商" align="center" width="200">
              <template slot-scope="scope2">
                <h6>采购供应商</h6>
                <span>{{ scope2.row.SupName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="资料提交状态" align="center" width="120">
              <template slot-scope="scope2">
                <h6>资料提交状态</h6>
                <span v-if="!scope2.row.IsDataSubmit">待提交</span>
                <span v-else-if="scope2.row.IsDataSubmit">已提交</span>
                <span v-else>/</span>
              </template>
            </el-table-column>
            <el-table-column label="供应商回款状态" align="center" width="120">
              <template slot-scope="scope2">
                <h6>供应商回款状态</h6>
                <span v-if="!scope2.row.IsSupReturnPay">待处理</span>
                <span v-else-if="scope2.row.IsSupReturnPay">已收款</span>
                <span v-else>/</span>
              </template>
            </el-table-column>
            <el-table-column label="运费" prop="Freight" align="center" width="120">
              <template slot-scope="scope2">
                <h6>运费</h6>
                <span>{{ scope2.row.Freight }}</span>
              </template>
            </el-table-column>
            <el-table-column label="承担方" align="center" width="140">
              <template slot-scope="scope2">
                <h6>承担方</h6>
                <span v-if="scope2.row.BearFreight == 1">营客通承担</span>
                <span v-else-if="scope2.row.BearFreight == 2">客户承担</span>
                <span v-else-if="scope2.row.BearFreight == 3">供应商承担</span>
                <span v-else-if="scope2.row.BearFreight == 4">无需运费</span>
                <span v-else>/</span>
              </template>
            </el-table-column>
            <el-table-column label="资料提交" align="center" width="100">
              <template slot-scope="scope2">
                <h6>资料提交</h6>
                <el-button type="primary" size="mini" v-if="scope2.row.IsNeedSubmitData && !scope2.row.IsDataSubmit"
                  @click="openInfoDialog(scope2.row)">提交资料
                </el-button>
                <span v-else>/</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="text-align: left">
          <p v-for="(item, index) in showRefundInfo.TrackList" :key="index">
            <span>{{ item.Description }}</span>&nbsp;&nbsp;<span>{{ item.CreateTime }}</span>&nbsp;&nbsp;<span>{{
              item.OperatorName
            }}</span>
          </p>
        </div>
        <div label="操作" fixed="right" align="center" width="200">
          <el-button size="small" type="success" style="margin-bottom: 10px" @click="handleClose()">关闭窗口
          </el-button>
          <el-button size="small" type="success" style="margin-bottom: 10px" @click="handleDetail(showRefundInfo)">详情
          </el-button>
          <el-button size="mini" type="success" style="margin-bottom: 10px"
            v-if="isShowPass && showRefundInfo.businessStatus == 0" @click="passBtn(showRefundInfo)">
            通过
          </el-button>
          <el-button size="mini" type="danger" style="margin-bottom: 10px"
            v-if="isShowRefuse && showRefundInfo.businessStatus == 0" @click="refuseBtn(showRefundInfo)">拒绝
          </el-button>
          <el-button size="mini" type="primary" style="margin-bottom: 10px" v-if="isShowApproval &&
            showRefundInfo.auditStatus == 0 &&
            showRefundInfo.businessStatus == 1 &&
            showRefundInfo.FinanceStatus == 0
            " @click="submitApproval(showRefundInfo)">提交审批
          </el-button>
          <el-button size="mini" type="warning" style="margin-bottom: 10px" v-if="isShowCancel &&
            showRefundInfo.auditStatus == 1 &&
            showRefundInfo.FinanceStatus == 0
            " @click="cancelBtn(showRefundInfo)">取消
          </el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 图片放大 -->
    <el-dialog :visible.sync="dialogBigImgVisible">
      <img style="width: 100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <!-- 星链申请退货 -->
    <el-dialog title="星链申请退货" :visible.sync="dialogStartlinkVisible" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="供应商名称：">
          <span>{{ afterSaleOrderStarData.RecieveName }}</span>
        </el-form-item>
        <el-form-item label="供应商手机号：">
          <span>{{ afterSaleOrderStarData.RecievePhone }}</span>
        </el-form-item>
        <el-form-item label="供应商收货地址：">
          <span>{{ afterSaleOrderStarData.RecieveAddr }}</span>
        </el-form-item>
        <el-form-item label="物流公司：">
          <el-select v-model="afterSaleOrderStarData.DeliveryCorpSn" filterable placeholder="请选择物流公司">
            <el-option v-for="(item, index) in logisticsList" :key="index" :label="item.ShortName"
              :value="item.ExpressHundredCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号：">
          <el-input v-model="afterSaleOrderStarData.DeliverySn"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" v-preventClick @click="confirmDeliveryBtn">确认发货</el-button>
      </div>
    </el-dialog>
    <!-- 开普勒售后 -->
    <el-dialog title="开普勒申请售后" :visible.sync="dialogCtpVisible1" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="售后数量：">
          <el-input v-model.number="applyCtpForm.quantity"></el-input>
        </el-form-item>
        <el-form-item label="售后类型：">
          <el-select v-model="applyCtpForm.afsType" @change="changeAfsType">
            <el-option v-for="(item, index) in ctpAfterSaleType" :key="index" :value="item.afsType"
              :label="item.afsTypeName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="售后原因：">
          <el-select v-model="applyCtpForm.reason" @change="changeCtpReason">
            <el-option v-for="(item, index) in ctpAfterSaleReason" :key="index" :value="item"
              :label="item.applyReasonName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题描述图片：" v-if="applyCtpForm.needUploadPic">
          <draggable :list="PicInfoList" :group="{ sort: true, animation: 500 }">
            <div class="img_box" v-for="(item, index) in PicInfoList" :key="index">
              <p class="del_box" @click.stop="handleDelPic(index)">
                <img src="../../../assets/del-icon.png" alt />
              </p>
              <img :src="item" alt @click.stop="handleBigPic(item)" />
            </div>
            <el-upload class="avatar-uploader border-one" action :show-file-list="false" :auto-upload="false"
              :on-change="handleUploadProfilePic" multiple>
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </draggable>
        </el-form-item>
        <el-form-item label="是否收到货：">
          <el-radio-group v-model="applyCtpForm.isReceived" @change="changeIsReceived">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="取件方式：">
          <el-select v-model="applyCtpForm.pickWareType">
            <el-option :value="4" label="上门取件"></el-option>
            <el-option :value="8" label="大家电上门取件"></el-option>
            <el-option :value="40" label="客户发货"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收货地区:">
          <!-- 省 -->
          <el-select v-model="provinceName" placeholder="请选择省" @change="handleProvince" style="width: 150px">
            <el-option v-for="item in provinceList" :key="item.Id" :label="item.AreaName" :value="item"></el-option>
          </el-select>
          <!-- 市 -->
          <el-select v-model="cityName" placeholder="请选择市" @change="handleCity" style="width: 150px">
            <el-option v-for="item in cityList" :key="item.Id" :label="item.AreaName" :value="item"></el-option>
          </el-select>
          <!-- 区 -->
          <el-select v-model="countyName" placeholder="请选择区" @change="handleArea" style="width: 150px">
            <el-option v-for="item in areaList" :key="item.Id" :label="item.AreaName" :value="item"></el-option>
          </el-select>
          <!-- 街道 -->
          <el-select v-model="townName" placeholder="请选择街道" @change="handleStreet" style="width: 150px">
            <el-option v-for="item in streetList" :key="item.Id" :label="item.AreaName" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收货地址：">
          <el-input v-model="applyCtpForm.address" style="width: 270px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" v-preventClick @click="submitCtpAfterSale">提交</el-button>
      </div>
    </el-dialog>
    <!-- 取消开普勒售后 -->
    <el-dialog title="开普勒取消售后" :visible.sync="dialogCtpVisible2" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="取消售后原因：">
          <el-select v-model="cancelCtpForm.cancelReasonCode">
            <el-option :value="1" label="订单不能按预计时间送达"></el-option>
            <el-option :value="2" label="其他渠道价格更低"></el-option>
            <el-option :value="3" label="该商品降价了"></el-option>
            <el-option :value="4" label="不想买了"></el-option>
            <el-option :value="5" label="其他原因"></el-option>
            <el-option :value="6" label="操作有误（商品、地址等选错）"></el-option>
            <el-option :value="7" label="商品无货"></el-option>
            <el-option :value="100" label="其他"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" v-preventClick @click="cancelCtpAfterSale">取消售后</el-button>
      </div>
    </el-dialog>
    <!-- 定责标签 -->
    <el-dialog title="设置定责" :visible.sync="showResponsibilityTag" :close-on-click-modal="false" width="30%">
      <el-form>
        <el-form-item label="定责标签：">
          <el-radio-group v-model="responseTag.tagType" size="mini">
            <el-radio-button :label="1">发货时效</el-radio-button>
            <el-radio-button :label="2">无货</el-radio-button>
            <el-radio-button :label="3">采购失败</el-radio-button>
            <el-radio-button :label="4">即下即退</el-radio-button>
            <el-radio-button :label="5">无理由</el-radio-button>
            <el-radio-button :label="6">物流超区</el-radio-button>
            <el-radio-button :label="7">质量问题</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="定责描述：">
          <el-input type="textarea" style="width: 300px" v-model="responseTag.tag"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="submitTag">提交</el-button>
      </div>
    </el-dialog>

    <!-- 京东慧采售后 -->
    <el-dialog title="京东慧采申请售后" :visible.sync="dialogCtpVisible3" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="售后数量：">
          <el-input v-model.number="applyJDHCForm.SkuNum"></el-input>
        </el-form-item>
        <el-form-item label="售后类型：">
          <el-select v-model="applyJDHCForm.CustomerExpect">
            <el-option v-for="(item, index) in jdhcAfterSaleType" :key="index" :value="item.value" :label="item.title">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="售后问题描述：">
          <el-input v-model="applyJDHCForm.QuestionDesc"></el-input>
        </el-form-item>
        <el-form-item label="是否需要检测报告：">
          <el-radio-group v-model="applyJDHCForm.IsNeedDetectionReport">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="问题描述图片：" v-if="applyJDHCForm.QuestionPic">
          <draggable :list="PicInfoList" :group="{ sort: true, animation: 500 }">
            <div class="img_box" v-for="(item, index) in PicInfoList" :key="index">
              <p class="del_box" @click.stop="handleDelPic(index)">
                <img src="../../../assets/del-icon.png" alt />
              </p>
              <img :src="item" alt @click.stop="handleBigPic(item)" />
            </div>
            <el-upload class="avatar-uploader border-one" v-if="PicInfoList.length < 3" action :show-file-list="false"
              :auto-upload="false" :on-change="handleUploadProfilePic" multiple>
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </draggable>
        </el-form-item>
        <el-form-item label="是否有包装：">
          <el-radio-group v-model="applyJDHCForm.IsHasPackage" @change="changeJDHCIsPackage">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="包装描述：">
          <el-select :disabled="!applyJDHCForm.IsHasPackage" v-model="applyJDHCForm.PackageDesc">
            <el-option v-for="(item, index) in jdhcAfterPackageDesc" :key="index" :value="item.value"
              :label="item.title"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系人：">
          <el-input v-model="applyJDHCForm.Customer.CustomerContactName"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：">
          <el-input v-model="applyJDHCForm.Customer.CustomerTel"></el-input>
        </el-form-item>
        <el-form-item label="联系手机号码：">
          <el-input v-model="applyJDHCForm.Customer.CustomerMobilePhone"></el-input>
        </el-form-item>
        <el-form-item label="取件方式：">
          <el-select v-model="applyJDHCForm.Pickware.PickwareType">
            <el-option :value="4" label="上门取件"></el-option>
            <el-option :value="7" label="客户送货"></el-option>
            <el-option :value="40" label="客户发货"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="取件地区:">
          <!-- 省 -->
          <el-select v-model="provinceName" placeholder="请选择省" @change="handleProvince" style="width: 150px">
            <el-option v-for="item in provinceList" :key="item.Id" :label="item.AreaName" :value="item"></el-option>
          </el-select>
          <!-- 市 -->
          <el-select v-model="cityName" placeholder="请选择市" @change="handleCity" style="width: 150px">
            <el-option v-for="item in cityList" :key="item.Id" :label="item.AreaName" :value="item"></el-option>
          </el-select>
          <!-- 区 -->
          <el-select v-model="countyName" placeholder="请选择区" @change="handleArea" style="width: 150px">
            <el-option v-for="item in areaList" :key="item.Id" :label="item.AreaName" :value="item"></el-option>
          </el-select>
          <!-- 街道 -->
          <el-select v-model="townName" placeholder="请选择街道" @change="handleStreet" style="width: 150px">
            <el-option v-for="item in streetList" :key="item.Id" :label="item.AreaName" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="取件地址：">
          <el-input v-model="applyJDHCForm.Pickware.PickwareAddress" style="width: 270px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" v-preventClick @click="submitJdCH">提交</el-button>
      </div>
    </el-dialog>
    <!-- 确认扣除盟友豆 -->
    <el-dialog title="确认扣除" :visible.sync="showTakeoffBean" :close-on-click-modal="false" width="30%">
      <div style="display: flex;margin-bottom:15px;">
        <span>当前金豆账户：</span>
        <span>{{ curBeanData.AvailableMemberRebate }}</span>
      </div>
      <div style="display: flex;margin-bottom:15px;">
        <span>需扣除：</span>
        <span>{{ curBeanData.DeductMemberRebate }}</span>
      </div>
      <p style="color:red;" v-if="curBeanData.DeductRefundAmount > 0">
        当前账户不足抵扣，需折价为金额扣款，在退款金额中扣除折合扣除金额：-¥{{ curBeanData.DeductRefundAmount }}
      </p>
      <div slot="footer">
        <el-button type="primary" @click="submitTakeoffBean">确认</el-button>
      </div>
    </el-dialog>
    <!-- 票据信息 -->
    <el-dialog title="票据信息" :visible.sync="showBill" :close-on-click-modal="false" width="80%">
      <div style="display: flex;margin-bottom:15px;display:flex;align-items:center;color:red;">
        <i class="el-icon-warning-outline" style="margin-right:5px;"></i>该订单已开票，需上传票据后才可退款！
      </div>
      <el-table :data="billData" border>
        <el-table-column label="ID" align="center" prop="Id"></el-table-column>
        <el-table-column label="账号" align="center" width="130" prop="AccountName">
          <template slot-scope="scope">
            <p>{{ scope.row.AccountName }}</p>
            <el-tag size="mini" type="danger" v-if="scope.row.IsBlockedBusinesses">黑名单</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="申请人" align="center" width="130" prop="NickName"></el-table-column>
        <el-table-column label="用户类型" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.AccountType == 1">商家</span>
            <span v-if="scope.row.AccountType == 2">C端</span>
            <span v-if="scope.row.Source == 1">个人开票</span>
            <span v-if="scope.row.Source == 2">京东店铺分销商开票</span>
          </template>
        </el-table-column>
        <el-table-column label="申请开票金额" align="center">
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.ApplyInvoiceAmount }}</span>
              <span style="color: red" v-if="scope.row.RefundAmount > 0">(退款金额：{{ scope.row.RefundAmount }})</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="剩余开票金额" align="center" width="130" prop="UnSplitInvoiceAmount"></el-table-column>
        <el-table-column label="发票类型" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.InvoiceType == 1">普通发票</span>
            <span v-else-if="scope.row.InvoiceType == 2">专业发票</span>
            <span v-else>个人发票</span>
          </template>
        </el-table-column>
        <el-table-column label="名称（抬头）" align="center" width="300" prop="InvoiceTitle"></el-table-column>
        <el-table-column label="纳税人识别号" align="center" width="200" prop="TIN"></el-table-column>
        <el-table-column label="地址" align="center" width="400" prop="TaxPayerAddress"></el-table-column>
        <el-table-column label="电话" align="center" width="130" prop="TaxPayerPhone"></el-table-column>
        <el-table-column label="开户行" align="center" width="400" prop="TaxPayerBankName"></el-table-column>
        <el-table-column label="银行账号" align="center" width="200" prop="TaxPayerBankNo"></el-table-column>

        <el-table-column label="开票状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.InvoiceStatus == 0">待开票</span>
            <span v-else-if="scope.row.InvoiceStatus == 1">已开票</span>
            <span v-else-if="scope.row.InvoiceStatus == 2">待作废</span>
            <span v-else-if="scope.row.InvoiceStatus == 3">已作废</span>
            <span v-else-if="scope.row.InvoiceStatus == 4">待重开</span>
            <span v-else-if="scope.row.InvoiceStatus == 5">已重开</span>
            <span v-else-if="scope.row.InvoiceStatus == 6">已拒绝</span>
            <span v-else-if="scope.row.InvoiceStatus == 7">已失败</span>
          </template>
        </el-table-column>
        <el-table-column label="发票号码" align="center" prop="Fphm" width="200"></el-table-column>
        <el-table-column label="发票代码" align="center" prop="Fpdm" width="200"></el-table-column>
        <el-table-column label="申请时间" align="center" prop="CreateTime" width="200"></el-table-column>
        <el-table-column label="开票时间" align="center" prop="ApplyTime" width="200"></el-table-column>
        <el-table-column label="线下开票" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.IsOfflineInvoice">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column label="失败原因" align="center" width="200" prop="QueryResultMsg">
        </el-table-column>
      </el-table>
      <el-form label-width="60px" style="margin-top:15px;">
        <el-form-item label="图片：">
          <div class="profile_img_box" v-if="uploadFileUrl">
            <p class="del_box" @click.stop="handleDelBillPic">
              <img src="../../../assets/del-icon.png" alt />
            </p>
            <img :src="uploadFileUrl" alt @click.stop="handleBigPic(uploadFileUrl)" />
          </div>
          <el-upload v-else class="avatar-uploader" action :show-file-list="false" :auto-upload="false"
            :on-change="handleUploadPic">
            <i class="el-icon-plus avatar-uploader-icon plus-sign"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="handleUploadBillPicSubmit">提交</el-button>
      </div>
    </el-dialog>
    <!-- 奥克斯售后 -->
    <el-dialog title="奥克斯申请售后" :visible.sync="auxAftersaleDialog" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="售后原因：">
          <el-select v-model="auxAftersaleReasonId" @change="changeCtpReason">
            <el-option v-for="(item, index) in auxAsReson" :key="index" :value="item.id" :label="item.text"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" v-preventClick @click="handleSubmitAuxAS">提交</el-button>
      </div>
    </el-dialog>
    <!-- 查看苏宁有货售后 -->
    <el-dialog title="苏宁有货售后" :visible.sync="snAftersaleDialog" :close-on-click-modal="false">
      <el-button type="primary" v-show="suningAsData.IsCanApply" @click="suningAsApply">申请售后</el-button>
      <el-button type="primary" plain v-show="suningAsData.IsCanCancel" @click="suningAsCancl">取消售后</el-button>
      <el-button type="primary" plain @click="suningLogSubmit" v-show="suningAsData.IsReturnLogistics">提交退货物流</el-button>
      <el-button type="primary" plain @click="suningConfirmReceive"
        v-show="suningAsData.IsChangeConfirmReceipt">换货确认收货</el-button>
    </el-dialog>
    <!-- 申请苏宁有货售后 -->
    <el-dialog title="申请苏宁有货售后" :visible.sync="snAftersaleApplyDialog" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="类型">
          <el-radio-group v-model="snAsForm.srvStatus">
            <el-radio :label="item.SrvStatus" v-for="(item, i) in suningAsData.SrvList" :key="i">{{ item.SrvName
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="原因">
          <el-select v-model="snAsForm.reasonCode" placeholder="请选择">
            <el-option v-for="(reason, s) in snReasonList" :key="s" :label="reason.Key" :value="reason.Value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="包装" v-if="suningAsData.LogisticsList && suningAsData.LogisticsList.length">
          <el-select v-model="snAsForm.logisticsCode" placeholder="请选择">
            <el-option v-for="(p, s) in suningAsData.LogisticsList" :key="s" :label="p.Key" :value="p.Value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" v-preventClick @click="handleSubmitSnAS">提交</el-button>
      </div>
    </el-dialog>
    <!-- 申请苏宁有货售后 提交退货物流 -->
    <el-dialog title="申请苏宁有货售后 - 提交退货物流" :visible.sync="snAftersaleLogSubmitDialog" :close-on-click-modal="false">

      <el-form>
        <el-form-item label="物流公司：">
          <el-select v-model="snAsLogisticsForm.logisticsCompanyId" filterable placeholder="请选择物流公司">
            <el-option v-for="(item, index) in logisticsList" :key="index" :label="item.ShortName"
              :value="item.ExpressHundredCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号：">
          <el-input v-model="snAsLogisticsForm.logisticsCode"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" v-preventClick @click="handleSnLogisticsSubmit">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog v-if="detailDialog" title="处理跟进" width="70%" :visible.sync="detailDialog" :close-on-click-modal="false">
      <el-form class="demo-form-inline fixShape">
        <el-form-item label="进度信息：">
          <el-input style="width: 400px;" type="textarea" :autosize="{ minRows: 4, maxRows: 10 }" placeholder="请输入内容"
            v-model="textarea2">
          </el-input>
        </el-form-item>
        <el-form-item label="图片上传：">
          <div style="display: inline-block" class="img_box1" v-for="(item, index) in UploadFileUrl">
            <p class="del_box" @click.stop="handleDelPic1(index)">
              <img src="../../../assets/del-icon.png" alt />
            </p>
            <img :src="item" alt @click.stop="handleBigPic(item)" />
          </div>
          <el-upload style="display: inline-block" class="avatar-uploader" action :show-file-list="false"
            :auto-upload="false" :on-change="handleBusinessPic">
            <i class="el-icon-plus avatar-uploader-icon plus-sign"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <h3>更新记录</h3>
      <div v-loading="markLoading">
        <el-card style="margin-bottom:20px;" v-for="(item, index) in remarkList">
          <div style="margin:10px;">
            <el-row>
              <el-col :span="18">
                {{ item.note }} <br />
                <h4>{{ item.createUser }} &nbsp;&nbsp;{{ item.createTime }}</h4>
              </el-col>
              <el-col :span="6">
                <img :src="item1" style="width:80px;height:80px;margin-right:5px;cursor: pointer;"
                  v-for="(item1, index1) in item.pics" />
              </el-col>
            </el-row>

          </div>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemark">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import toolbar from "../../../components/Toolbar";
import ApprovalProcess from "../../../components/ApprovalProcess.vue";
import {
  afterSaleOrderList,
  afterExportList,
  GetAfterSaleOrderSupList,
  BusinessAdopt,
  getQiniuToken,
  SubmitSupData,
  AfterSaleOrderSubmitAudit,
  AfterSaleOrderUnSubmitAudit,
  businessRefuse,
  purListV3,
  AfterChangeEnvelopeMoney,
  StarApplyRefund,
  StarApplyRefundAndGoods,
  LogisticsCompanyStarList,
  StarReturnOrderGoods,
  StarCancelApplyRefund,
  JDCtpIsCanApply,
  JDCtpGetApplyReason,
  JDCtpCreateAfsApply,
  JDHCIsCanApply,
  JDCtpCancelOrder,
  areaList,
  AfterChangeCouponMoney,
  SetResponsibilityTag,
  DeductMemberRebateAmount,
  DeductGroupBookingEarnestMoney,
  AfterSaleOrderDeductMemberRebate,
  UpdateReverseTicketPic,
  AfterSaleOrderInvoiceInfo,
  AUXRefundOrder,
  SNYHAftersalesDetail,
  SNYHApplyAftersales,
  SNYHCancelAftersales,
  SNYHReturnLogistics,
  SNYHChangeConfirmReceipt,
  AfterSaleOrderErpList,
  OrderAfterSaleErpList,
  AfterSaleOrderAuditRefuse,
  AfterSaleOrderAuditPass,
  OrderAfterSaleErpListCount,
  OrderCreateOrderNote,
  OrderGetOrderNoteList,
  AddAfterSaleOrderNote, GetAfterSaleOrderNoteList
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";

export default {
  components: { toolbar, ApprovalProcess },
  filters: {
    tagTypeName(tag) {
      let name = {
        1: '发货时效',
        2: '无货',
        3: '采购失败',
        4: '即下即退',
        5: '无理由',
        6: '物流超区',
        7: '质量问题'
      }
      return name[tag]
      // if (tag==1) {
      //   return
      // }
    }
  },
  data() {
    return {
      markLoading: false,
      remarkList: [],
      noteId: null,
      UploadFileUrl: [],
      textarea2: '',
      detailDialog: false,
      remarkShow: false,
      waitHandle: 0,
      alreadyHandle: 0,
      alreadyRefuse: 0,
      overTime: 0,
      orderStatus: 0,
      orderStatusIsTrue: false,
      tabList: [
        {
          label: "待处理",
          id: 0,
          num: 0
        },
        {
          label: "已通过",
          id: 2,
          num: 0
        },
        {
          label: "已拒绝",
          id: 4,
          num: 0
        },
        {
          label: "超时未处理",
          id: true,
          num: 0
        }
      ],
      selectedIndex: 1,
      allowDeductMemberRebateAmount: false,
      showResponsibilityTag: false,
      dialogImageUrl: "",
      dialogBigImgVisible: false,
      isShowPass: false,
      isShowRefuse: false,
      isShowApproval: false,
      isShowCancel: false,
      dialogInfoVisible: false,
      showInfoVisible: false,
      showDeductMemberRebateBtn: false,
      isCheckBill: false,
      form: {
        keyWord: '',
        pageIndex: 1,
        pageSize: 10,
        type: 4,
        isNotAuditFor24: null,
        PurchaseSaleStatus: -1,
        handleStatus: 0,
        selected1: 0,
        selectedIndex: 0,
        RefundStatus: -1,
        OrderNo: null,
        ApplyUser: null,
        SupReturnPayStatus: -1,
        FinanceStatus: -1,
        applyTimeStart: null,
        applyTimeEnd: null,
      },
      loading: false,
      itemData: null,
      orderList: [],
      total: 0,
      valueTime: null,

      refundVisible: false,

      buttonList_table: [],
      buttonList_toolBar: [],
      activeName: "first",
      afterSaleOrderSup: [],
      afterSaleOrderId: null,
      qiniuToken: "",
      infoForm: {
        id: null,
        inspectionSheePic: null,
        supReceiptPic: null,
        externalOrderId: null,
        remark: "",
        supReturnPayMode: 1,
      },
      showRefundInfo: {},
      applySkuNumber: 0,
      unPurchaseNumber: 0,
      showUnPurchaseNumber: true,
      remark: "",
      isDeductDepositAmount: true, // 是否扣除预售定金
      purRecList: [],
      dialogStartlinkVisible: false,
      afterSaleOrderStarData: {},
      logisticsList: [],
      dialogCtpVisible1: false,
      dialogCtpVisible2: false,
      dialogCtpVisible3: false,
      ctpAfterSaleType: [],
      ctpAfterSaleReason: [],
      applyCtpForm: {
        afsType: null,
        applyReasonId: null,
        applyReasonName: null,
        needUploadPic: null,
        quantity: 1,
        questionPic: null,
        isReceived: false,
        pickWareType: null,
        address: "",
        reason: null,
      },
      jdhcAfterSaleType: [{ title: "退货", value: 10 }],
      jdhcAfterPackageDesc: [
        { title: "无包装", value: 0 },
        { title: "包装完整", value: 10 },
        {
          title: "包装破损",
          value: 20,
        },
      ],
      applyJDHCForm: {
        AfterSaleOrderId: 0, //售后订单ID
        SkuNum: 0, //商品申请数量(必填)
        CustomerExpect: 10, //售后类型(必选) ：退货(10)、换货(20)
        QuestionDesc: "", //产品问题描述，最多1000字符
        IsNeedDetectionReport: false, //是否需要检测报告(必选)
        QuestionPic: [], //问题描述图片  数组
        IsHasPackage: false, //是否有包装(必选)
        PackageDesc: 0, //包装描述(必选):0 无包装 10 包装完整 20 包装破损
        Customer: {
          CustomerContactName: "", // 联系人(必填)，最多50字符
          CustomerTel: "", //联系电话(必填)，最多50字符
          CustomerMobilePhone: "", //CustomerMobilePhone
        },
        Pickware: {
          PickwareType: 4, //取件方式(必选)：4上门取件； 7 客户送货；40客户发货
          PickwareProvince: null, //取件省(必选)
          PickwareCity: null, //取件市(必选)
          PickwareCounty: null, //取件县(必选)
          PickwareVillage: null, //取件乡镇(必选)
          PickwareAddress: null, //取件街道地址(必填)
        },
      },
      cancelCtpForm: {
        cancelReasonCode: null,
      },
      PicInfoList: [],

      provinceList: [],
      cityList: [],
      areaList: [],
      streetList: [],

      provinceName: null,
      cityName: null,
      countyName: null,
      townName: null,

      provinceId: null,
      cityId: null,
      countyId: null,
      townId: null,
      thiredOrderType: 7,
      isPresell: false,
      responseTag: {
        id: null,
        tagType: null,
        tag: "",
      },
      canRefund: false,

      showTakeoffBean: false,
      curBeanData: {},

      showBill: false,
      uploadFileUrl: null,
      curId: 0,
      billData: [],

      isAuxAftersale: false,
      auxAftersaleDialog: false,
      auxAfterSaleOrderId: null,
      auxAftersaleReasonId: null,
      auxAsReson: [
        { id: 1, text: '不想要了' },
        { id: 2, text: '包装破损' },
        { id: 3, text: '机器损坏' },
        { id: 4, text: '物流延迟' },
        { id: 5, text: '价格太高' },
        { id: 6, text: '性能不好' },
        { id: 99, text: '其他原因' },
      ],
      // 苏宁有货售后
      isSuningAftersale: false,
      isSuningAftersaleApply: false,
      isSuningAftersaleCancl: false,
      isSuningAftersaleSubmitLogistics: false,
      isSuningAftersaleChangeConfirmReceive: false,
      snAftersaleDialog: false,
      snAftersaleApplyDialog: false,
      suningAfterSaleOrderId: null,
      suningAsData: {},
      snAsForm: {
        srvStatus: null,
        productRetMoney: null,
        reasonCode: null,
        logisticsCode: null
      },
      snReasonList: [],
      snAsLogisticsForm: {
        logisticsCompanyId: null,
        logisticsCode: null
      },
      snAftersaleLogSubmitDialog: false
    };
  },
  watch: {
    'snAsForm.srvStatus'(n, o) {
      if (n) {
        this.validSuningAs(n, (f) => {
          this.snAsForm.reasonCode = null
          this.snAsForm.productRetMoney = f.ProductRetMoney
          this.snReasonList = f.ReasonList
        })
      }
    }
  },
  mounted() {
    this.getCount();
    this.getAfterSaleOrderList();
    // this.getQiniuToken();/**/
    // this.getLogisticsList()
  },
  methods: {
    async submitRemark() {
      if (!this.textarea2) {
        return this.$message.error('请填写备注信息')
      }
      let params = {};
      params.afterSaleOrderId = this.noteId;
      params.note = this.textarea2;
      params.images = this.UploadFileUrl.join(',') || '';
      let res = await AddAfterSaleOrderNote(params);
      if (res.data.success) {
        this.textarea2 = '';
        this.UploadFileUrl = [];
        this.detailDialog = false;
        this.$message.success('添加备注成功')
        await this.getAfterSaleOrderList();
      } else {
        this.$message.error(res.data.error.message)
      }
      console.log('res beizhu add', res);
    },
    async showRemark(row) {
      this.markLoading = true;
      this.noteId = row.id;
      let res = await GetAfterSaleOrderNoteList({ afterSaleOrderId: row.id })
      console.log('备注列表', res);
      if (res.data.success) {
        this.markLoading = false;
        if (res.data.result) {
          res.data.result.data.forEach((item, index) => {
            if (item.images) {
              item.pics = item.images.split(',')
            }
          })
        }
        this.remarkList = res.data.result.data
      } else {
        this.markLoading = false;
        this.$message.error(res.data.error.message);
      }
      this.detailDialog = true;
    },
    handleBusinessPic(file) { // 上传图片
      console.log(123)
      let that = this;
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.png`,
        token: this.qiniuToken
      };
      that.$utils
        .uploadImgToQiniu(file.raw, qiniuData)
        .then(res => {
          console.log('qiniu res', res);
          this.UploadFileUrl.push(res);
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    handleDelPic1(index) { // 删除图片
      this.UploadFileUrl.splice(index, 1);
    },
    async getCount() {
      let res = await OrderAfterSaleErpListCount(this.form);
      if (res.data.success) {
        if (res.data.result.data) {
          this.waitHandle = res.data.result.data.count0;
          this.alreadyHandle = res.data.result.data.count2;
          this.alreadyRefuse = res.data.result.data.count4;
          this.overTime = res.data.result.data.countNotAuditFor24;
        }
      } else {
        this.$message.error(res.data.error.message || '获取数据失败, 请重试')
      }

      console.log('res', res);
    },
    handOrderStatus(index) {
      this.orderStatus = index;
      this.orderStatusIsTrue = false;
      this.form.handleStatus = index;
      this.form.IsNotAuditFor24 = null;
      this.getAfterSaleOrderList();
      // this.selectedIndex = item.id
      // console.log('selectedIndex',this.selectedIndex)
      // this.PageIndex = 1;
      // this.searchData.Status = item.id;
      // this.queryData();
    },
    handOrderStatusTrue(index) {
      this.orderStatus = -1;
      this.orderStatusIsTrue = true;
      this.form.IsNotAuditFor24 = true;
      this.form.handleStatus = -1;
      this.getAfterSaleOrderList();
      // this.selectedIndex = item.id
      // console.log('selectedIndex',this.selectedIndex)
      // this.PageIndex = 1;
      // this.searchData.Status = item.id;
      // this.queryData();
    },
    changeIndex(i) {
      this.form.handleStatus = Number(i);
      this.form.selected1 = Number(i);
    },
    // 苏宁有货售后 start
    suningAftersaleBtn(data) {
      this.suningAfterSaleOrderId = data.Id
      this.getSuningAsDetail()
      this.snAftersaleDialog = true
    },
    getSuningAsDetail() {
      SNYHAftersalesDetail({
        afterSaleOrderId: this.suningAfterSaleOrderId
      }).then(res => {
        if (res.data.success) {
          this.suningAsData = res.data.response
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    suningAsCancl() {
      this
        .$confirm("确定取消售后吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          SNYHCancelAftersales({ afterSaleOrderId: this.suningAfterSaleOrderId }).then(res => {
            if (res.data.success) {
              this.getSuningAsDetail()
            } else {
              this.$message.error(res.data.msg);
            }
          })
        });
    },
    suningLogSubmit() {
      this.snAsLogisticsForm = {
        logisticsCompanyId: null,
        logisticsCode: null
      }
      this.snAftersaleLogSubmitDialog = true
    },
    handleSnLogisticsSubmit() {
      if (!this.snAsLogisticsForm.logisticsCompanyId || !this.snAsLogisticsForm.logisticsCode) {
        return this.$message.error('请填写完整数据')
      }
      SNYHReturnLogistics({
        afterSaleOrderId: this.suningAfterSaleOrderId,
        logisticsCompanyId: this.snAsLogisticsForm.logisticsCompanyId,
        logisticsCode: this.snAsLogisticsForm.logisticsCode
      }).then(res => {
        if (res.data.success) {
          this.getSuningAsDetail()
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    suningConfirmReceive() {
      this
        .$confirm("确定确认收货吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          SNYHChangeConfirmReceipt({
            afterSaleOrderId: this.suningAfterSaleOrderId
          }).then(res => {
            if (res.data.success) {
              this.getSuningAsDetail()
            } else {
              this.$message.error(res.data.msg);
            }
          })
        });
    },
    suningAsApply() {
      this.snAftersaleApplyDialog = true
    },
    // 苏宁有货售后验证
    validSuningAs(status, cb) {
      const f = this.suningAsData.SrvList.find(i => i.SrvStatus == status)
      if (status == 1) { // 退货
        if (f.PermitRetStatus == 'A') {
          this.$message.error('不支持退货')
          return false
        }
      }
      if (status == 2) { // 换货
        if (f.PermitChgStatus == 'A') {
          this.$message.error('不支持换货')
          return false
        }
      }
      if (status == 3) { // 仅退款
        if (f.PermitRefStatus == 'B') {
          this.$message.error('不支持退款')
          return false
        }
      }
      if (cb) {
        cb(f)
      } else {
        return true
      }
    },
    handleSubmitSnAS() {
      const valide = this.validSuningAs(this.snAsForm.srvStatus)
      if (!valide) return
      SNYHApplyAftersales({
        ...this.snAsForm,
        afterSaleOrderId: this.suningAfterSaleOrderId
      }).then(res => {
        if (res.data.success) {
          this.snAftersaleApplyDialog = false
          this.getSuningAsDetail()
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    // 苏宁有货售后 end
    auxAftersaleBtn(data) {
      this.auxAfterSaleOrderId = data.Id
      this.auxAftersaleReasonId = null
      this.auxAftersaleDialog = true
    },
    handleSubmitAuxAS() {
      if (this.auxAftersaleReasonId) {
        AUXRefundOrder({
          afterSaleOrderId: this.auxAfterSaleOrderId,
          refundType: this.auxAftersaleReasonId
        }).then(res => {
          if (res.data.success) {
            this.$message.success('申请提交成功')
            this.getAfterSaleOrderList();
          } else {
            this.$message.error(res.data.msg);
          }
        })
      }
    },
    handleCheckBill(data) {
      this.curId = data.Id
      AfterSaleOrderInvoiceInfo({ id: data.id }).then(res => {
        if (res.data.success) {
          this.billData = res.data.response ? [res.data.response] : []
          this.uploadFileUrl = res.data.response ? res.data.response.ReverseTicketPic : null
          this.showBill = true
        } else {
          that.$message.error(res.data.msg);
        }
      })
    },
    handleDelBillPic() { // 删除图片
      this.uploadFileUrl = null
    },
    handleUploadPic(file) { // 上传图片
      let that = this;
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.png`,
        token: that.qiniuToken
      };
      that.$utils
        .uploadImgToQiniu(file.raw, qiniuData)
        .then(res => {
          that.uploadFileUrl = res;
        })
        .catch(err => {
          that.$message.error(err);
        });
    },
    handleUploadBillPicSubmit() {
      UpdateReverseTicketPic({
        AfterSaleOrderId: this.curId,
        reverseTicketPic: this.uploadFileUrl || ''
      }).then(res => {
        if (res.data.success) {
          this.$message.success('提交成功');
          this.showBill = false
          this.getAfterSaleOrderList();
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    handleTakeoffBean(data) {
      this.curBeanData = data
      this.showTakeoffBean = true
    },
    submitTakeoffBean() {
      AfterSaleOrderDeductMemberRebate({
        AfterSaleOrderId: this.curBeanData.Id
      }).then(res => {
        if (res.data.success) {
          this.$message.success('扣除成功');
          this.showTakeoffBean = false
          this.getAfterSaleOrderList();
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    groupRefund(row) {
      this
        .$confirm("是否确认退还定金金额?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          DeductGroupBookingEarnestMoney({ id: row.Id }).then(res => {
            if (res.data.success) {
              this.$message.success('扣除成功');
              this.getAfterSaleOrderList();
            } else {
              this.$message.error(res.data.msg);
            }
          })
        });
    },
    setLabelBtn(row) {
      this.showResponsibilityTag = true;
      this.responseTag.id = row.Id;
      this.responseTag.tag = "";
      this.responseTag.tagType = null;
    },
    submitTag() {
      if (!this.responseTag.tagType) {
        return this.$message.error('请选择定责标签')
      }
      SetResponsibilityTag(this.responseTag).then((res) => {
        if (res.data.success) {
          this.showResponsibilityTag = false;
          this.getAfterSaleOrderList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleUploadProfilePic(file) {
      let that = this;

      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils
        .uploadImgToQiniu(file.raw, qiniuData)
        .then((res) => {
          let itemPic;
          if (that.PicInfoList[0]) {
            itemPic = res;
          } else {
            itemPic = res;
          }
          that.PicInfoList.push(itemPic);
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    handleBigPic(src) {
      this.dialogBigImgVisible = true;
      this.dialogImageUrl = src;
    },
    handleDelPic(index) {
      let that = this;
      that.PicInfoList.splice(index, 1);
    },
    keplerCancelBtn(row) {
      //京东售后，京东开普勒与京东慧采：1慧采，7-11开普勒
      this.afterSaleOrderId = row.Id;
      this.thiredOrderType = row.thiredOrderType;
      this.getQiniuToken();
      this.PicInfoList = [];
      if (this.thiredOrderType == 1) {
        //京东慧采售后
        this.applyJDHCForm.AfterSaleOrderId = row.Id;
        this.dialogCtpVisible3 = true; //售后弹框
        this.getProvinceList();
      } else {
        //开普勒 7-11
        JDCtpIsCanApply({
          afterSaleOrderId: row.Id,
        }).then((res) => {
          if (res.data.success) {
            //如果已经发起售后了
            // this.dialogJdTitle = "开普勒申请售后"
            this.dialogCtpVisible1 = true; //售后弹框
            this.ctpAfterSaleType = res.data.response.afsSupportedTypes;
          } else {
            //无法售后，或者已经发起了售后
            if (RegExp(/不可发起售后/).test(res.data.msg)) {
              this.dialogCtpVisible2 = true; //取消售后的弹框
            } else {
              this.$message.error(res.data.msg);
            }
          }
        });
      }
    },
    changeAfsType(val) {
      this.applyCtpForm.afsType = val;
      this.getJDCtpGetApplyReason(val);
    },
    getJDCtpGetApplyReason(val) {
      let params = {
        afterSaleOrderId: this.afterSaleOrderId,
        afsType: val,
      };
      JDCtpGetApplyReason(params).then((res) => {
        if (res.data.success) {
          this.ctpAfterSaleReason = res.data.response.ApplyReason;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    changeCtpReason(val) {
      this.applyCtpForm.applyReasonId = val.applyReasonId;
      this.applyCtpForm.applyReasonName = val.applyReasonName;
      this.applyCtpForm.needUploadPic = val.needUploadPic;
      if (!val.NeedUploadPic) {
        this.PicInfoList = [];
      }
    },
    changeIsReceived(val) {
      // if(val){

      // }
      this.getProvinceList();
    },
    changeJDHCIsPackage() {
      this.applyJDHCForm.PackageDesc = 0;
    },
    submitCtpAfterSale() {
      //提交开普勒售后
      if (!this.applyCtpForm.afsType) {
        return this.$message.error("请选择售后类型！");
      }
      if (!this.applyCtpForm.applyReasonId) {
        return this.$message.error("请选择售后申请问题！");
      }
      if (!this.applyCtpForm.quantity) {
        return this.$message.error("请选择售后申请数量！");
      }
      let data = {
        provinceName: this.provinceName,
        cityName: this.cityName,
        countyName: this.countyName,
        townName: this.townName,
        address: this.applyCtpForm.address,
      };
      let params = {
        afterSaleOrderId: this.afterSaleOrderId,
        afsType: this.applyCtpForm.afsType,
        applyReasonName: this.applyCtpForm.applyReasonName,
        applyReasonId: this.applyCtpForm.applyReasonId,
        quantity: this.applyCtpForm.quantity,
        isReceived: this.applyCtpForm.isReceived,
        questionPic: this.PicInfoList.join(","),
      };
      if (this.applyCtpForm.isReceived) {
        params.pickWareType = this.applyCtpForm.pickWareType;
        params.address = data;
      }
      console.log(params, "请求参数");

      // return
      JDCtpCreateAfsApply(params).then((res) => {
        if (res.data.success) {
          this.getAfterSaleOrderList();
          this.dialogCtpVisible1 = false;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    submitJdCH() {
      //京东慧采退换货

      this.applyJDHCForm.Pickware.PickwareProvinceName = this.provinceName;
      this.applyJDHCForm.Pickware.PickwareCityName = this.cityName;
      this.applyJDHCForm.Pickware.PickwareCountyName = this.countyName;
      this.applyJDHCForm.Pickware.PickwareVillageName = this.townName;
      this.applyJDHCForm.Pickware.PickwareProvince = this.provinceId;
      this.applyJDHCForm.Pickware.PickwareCity = this.cityId;
      this.applyJDHCForm.Pickware.PickwareCounty = this.countyId;
      this.applyJDHCForm.Pickware.PickwareVillage = this.townId;
      this.applyJDHCForm.QuestionPic = this.PicInfoList;
      if (
        this.applyJDHCForm.Pickware.PickwareProvince == null ||
        this.applyJDHCForm.Pickware.PickwareCity == null ||
        this.applyJDHCForm.Pickware.PickwareCounty == null ||
        this.applyJDHCForm.Pickware.PickwareVillage == null ||
        this.applyJDHCForm.Pickware.PickwareAddress == null
      ) {
        return this.$message.error("请输入取件信息！");
      }
      JDHCIsCanApply(this.applyJDHCForm).then((res) => {
        if (res.data.success) {
          this.getAfterSaleOrderList();
          this.dialogCtpVisible3 = false;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    cancelCtpAfterSale() {
      if (!this.cancelCtpForm.cancelReasonCode) {
        return this.$message.error("请选择售后取消原因！");
      }
      let params = {
        afterSaleOrderId: this.afterSaleOrderId,
        cancelReasonCode: this.cancelCtpForm.cancelReasonCode,
      };
      JDCtpCancelOrder(params).then((res) => {
        if (res.data.success) {
          this.getAfterSaleOrderList();
          this.dialogCtpVisible2 = false;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleBigImg(img) {
      this.dialogBigImgVisible = true;
      this.dialogImageUrl = img;
    },
    startlinkCancelBtn(row) {
      this.$prompt("取消原因", "确认取消星链售后吗", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
      }).then(({ value }) => {
        StarCancelApplyRefund({
          afterSaleOrderId: row.Id,
          reason: value,
        }).then((res) => {
          if (res.data.success) {
            this.getAfterSaleOrderList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    confirmDeliveryBtn() {
      let params = {
        afterSaleOrderId: this.afterSaleOrderId,
        deliveryCorpSn: this.afterSaleOrderStarData.DeliveryCorpSn,
        deliverySn: this.afterSaleOrderStarData.DeliverySn,
      };
      StarReturnOrderGoods(params).then((res) => {
        if (res.data.success) {
          this.dialogStartlinkVisible = false;
          this.getAfterSaleOrderList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getLogisticsList() {
      LogisticsCompanyStarList().then((res) => {
        this.logisticsList = res.data.response;
      });
    },
    startlinkDeliveryBtn(row) {
      this.dialogStartlinkVisible = true;
      this.afterSaleOrderStarData = row.platformAfterSaleOrder[0];
      this.afterSaleOrderId = row.Id;
      this.getLogisticsList();
    },
    startlinkReturnBtn(row) {
      this.$confirm("确认申请星链退货吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
      }).then(() => {
        StarApplyRefundAndGoods({
          afterSaleOrderId: row.Id,
        }).then((res) => {
          if (res.data.success) {
            this.getAfterSaleOrderList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    startlinkRefundBtn(row) {
      this.$confirm("确认申请星链退款吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
      }).then(() => {
        StarApplyRefund({
          afterSaleOrderId: row.Id,
        }).then((res) => {
          if (res.data.success) {
            this.getAfterSaleOrderList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    couponRefund(row) {
      this.$prompt("请输入优惠金额", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
      }).then(({ value }) => {
        if (value <= 0) {
          return this.$message.error("优惠金额必须大于零！");
        }
        AfterChangeCouponMoney({
          Amount: value,
          AfterSaleOrderId: row.Id,
        }).then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.msg);
            this.getAfterSaleOrderList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    envelopeRefund(row) {
      this.$prompt("请输入红包金额", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
      }).then(({ value }) => {
        if (value <= 0) {
          return this.$message.error("红包金额必须大于零！");
        }
        AfterChangeEnvelopeMoney({
          Amount: value,
          AfterSaleOrderId: row.Id,
        }).then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.msg);
            this.getAfterSaleOrderList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 扣除解冻盟友金
    deductMemberRebateAmount(row) {
      this.$confirm("是否确认扣除盟友金？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        let params = {
          id: row.Id,
        };
        DeductMemberRebateAmount(params).then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.msg);
            this.getAfterSaleOrderList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    getPurRecList(row) {
      let params = {
        mainOrderId: row.mainOrderId,
        childOrderId: row.childOrderId,
      };
      purListV3(params).then((res) => {
        console.log('purListV3: ' + res.data.msg);
        this.purRecList = res.data.response;
      });
    },
    rowClick(row, column, event) {
      this.$set(row, "IsChecked", !row.IsChecked);
    },
    tableRowClassName(row, rowIndex) {
      if (row.row.IsChecked) {
        return "highlighted";
      }
    },
    handleRadio(value, item) {
      if (value === 4) {
        this.$set(item, "Freight", 0);
        this.$set(item, "FreightOperation", 3);
      }
    },
    refuseBtn(row) {
      this.$prompt("拒绝原因：", "确认拒绝审核吗", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        var param = {
          id: row.id,
          reason: value,
        };
        AfterSaleOrderAuditRefuse(param).then((res) => {
          if (res.data.success) {
            this.$message.success("操作成功");
            this.getAfterSaleOrderList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    cancelBtn(row) {
      let list = [];
      list.push(row.Id);
      this.$confirm("确认取消吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      }).then(() => {
        AfterSaleOrderUnSubmitAudit({
          afterSaleOrderIds: list,
        }).then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.msg);
            this.getAfterSaleOrderList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    submitApproval(row) {
      let list = [];
      list.push(row.Id);
      this.$confirm("确认提交审批吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      }).then(() => {
        AfterSaleOrderSubmitAudit({
          afterSaleOrderIds: list,
        }).then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.msg);
            this.getAfterSaleOrderList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    submitInfo() {
      SubmitSupData(this.infoForm).then((res) => {
        if (res.data.success) {
          this.$message.success(res.data.msg);
          this.dialogInfoVisible = false;
          this.dialogInfoVisible = false;
          this.getAfterSaleOrderList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    openInfoDialog(row) {
      this.getQiniuToken();
      this.dialogInfoVisible = true;
      this.infoForm = {
        id: row.Id,
        inspectionSheePic: null,
        supReceiptPic: null,
        externalOrderId: null,
        remark: "",
        supReturnPayMode: 1,
      };
    },
    //获取七牛token
    getQiniuToken() {
      var that = this;
      getQiniuToken().then((res) => {
        that.qiniuToken = res.data;
      })
        .catch(() => {
        });
    },
    handleChange(file, i) {
      // console.log(i,file,'WWWWWWW')
      let that = this;
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils
        .uploadImgToQiniu(file.raw, qiniuData)
        .then((res) => {
          if (i == 1) {
            that.$set(that.infoForm, "inspectionSheePic", res);
          } else if (i == 2) {
            that.$set(that.infoForm, "supReceiptPic", res);
          }
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    delPic(i) {
      if (i == 1) {
        this.infoForm.inspectionSheePic = null;
      } else {
        this.infoForm.supReceiptPic = null;
      }
    },
    handleSupbox(value, item) {
      item.isChecked = value;
    },
    async submitAfter() {
      let list = [];
      if (this.showUnPurchaseNumber) {
        if (this.afterSaleOrderSup.length > 0) {
          let checkedList = this.afterSaleOrderSup.filter((item) => {
            return item.isChecked;
          });
          if (checkedList.length <= 0) {
            return this.$message.error("请勾选要操作的供应商！");
          }
          let flag = checkedList.every((item) => {
            return (
              item.freight >= 0 ||
              item.undeliveredNumber >= 0 ||
              item.deliveredNumber >= 0
            );
          });
          if (!flag) {
            return this.$message.error(
              "请检查运费金额、未发货数量、已发货数量是否为空！"
            );
          }
          let number = this.unPurchaseNumber;
          checkedList.forEach((item) => {
            number += item.undeliveredNumber + item.deliveredNumber;
          });
          if (number != this.applySkuNumber) {
            return this.$message.error(
              "未采购数量、未发货数量、已发货数量相加之和只能等与申请退货数量！"
            );
          }
          for (let item of checkedList) {
            if (item.undeliveredNumber > item.surplusSendNumber) {
              this.$message.error(
                "退货的未发货数量不能大于该供应商的未发货数量!"
              );
              return false;
            } else if (item.deliveredNumber > item.sendSkuNumber) {
              this.$message.error(
                "退货的已发货数量不能大于该供应商的已发货数量！"
              );
              return false;
            } else {
              list.push({
                supId: item.buySupplierId,
                freight: item.freight,
                bearFreight: item.bearFreight,
                freightOperation: item.freightOperation,
                isRePurchase: item.isRePurchase,
                deliveredNumber: item.deliveredNumber,
                undeliveredNumber: item.undeliveredNumber,
                isNeedSubmitData: item.isNeedSubmitData,
              });
            }
          }
        }
      }
      let params = {
        afterSaleOrderId: this.afterSaleOrderId,
        afterSaleOrderSupList: list,
        remark: this.remark,
      };
      if (this.isPresell) {
        params.isDeductDepositAmount = this.isDeductDepositAmount;
      }

      let res = await AfterSaleOrderAuditPass(params)
      console.log('result: ', res);
      console.log('res.data.success', res.data.success)
      if (res.data.result && res.data.result.success) {
        this.$message.success(res.data.result.message);
        this.refundVisible = false;
        this.getAfterSaleOrderList();
      } else {
        if (res.data.result.message.indexOf("结算账户余额不足") !== -1) {
          this.$confirm('您的钱包余额不足无法进行退款！', '提示', {
            confirmButtonText: '前往钱包充值',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push(`/Financial/WalletAccount/Index`)
          }).catch(() => { });
        } else {
          this.$message.error(res.data.result.message)
        }
      }
    },
    passBtn(row) {
      console.log('row', row);
      this.getPurRecList(row);
      this.isPresell = row.isPresell;
      this.afterSaleOrderId = row.id;
      this.applySkuNumber = row.applySkuNumber;
      this.unPurchaseNumber = row.skuNumber - row.purchaserNumber;
      if (row.applySkuNumber > row.skuNumber - row.purchaserNumber) {
        this.showUnPurchaseNumber = true;
      } else {
        this.showUnPurchaseNumber = false;
      }
      console.log('childOrderId', row.childOrderId);
      GetAfterSaleOrderSupList({
        childOrderId: row.childOrderId,
      }).then((res) => {
        console.log('resresresres', res);
        if (res.data.success) {
          this.refundVisible = true;
          let list = res.data.result.data || [];
          list.forEach((item) => {

            item.freight = 0;
            item.bearFreight = 4;
            item.freightOperation = 1;
            item.isRePurchase = false;
            item.deliveredNumber = 0;
            item.undeliveredNumber = 0;
            item.isNeedSubmitData = false;
            item.isChecked = true;
          });
          this.afterSaleOrderSup = list;
          console.log('this.afterSaleOrderSup', this.afterSaleOrderSup);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    setCellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 11) {
        return "buyStyle";
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 11) {
        return [1, 7];
      } else if (columnIndex === 12) {
        return [0, 0];
      } else if (columnIndex === 13) {
        return [0, 0];
      } else if (columnIndex === 14) {
        return [0, 0];
      } else if (columnIndex === 15) {
        return [0, 0];
      } else if (columnIndex === 16) {
        return [0, 0];
      } else if (columnIndex === 17) {
        return [0, 0];
      }
    },
    handleClick() {
      if (this.activeName === "second") {
        this.$router.push("/AfterSalesService/AfterSaleList/ExchangeList");
      }
    },
    getAfterSaleOrderList() {
      let that = this;
      that.loading = true;
      // afterSaleOrderList(that.form).then((res) => {
      OrderAfterSaleErpList(that.form).then((res) => {
        if (res.data.success) {
          if (res.data.result && res.data.result.data.data) {
            res.data.result && res.data.result.data.data.forEach((item, index) => {
              if (item.afterSaleOrderNote) {
                item.afterSaleOrderNote.pics = item.afterSaleOrderNote.images.split(',')
              }
            })
          }
          that.loading = false;
          let list = res.data.result.data.data || [];
          list.forEach((item) => {
            item.IsChecked = false;
            if (item.attachUrl) {
              item.intro = item.attachUrl.split(',');
              console.log('item.Intro', item.intro);
            }
            if (item.certificateUrl) {
              item.evidence = item.certificateUrl.split(',');
              console.log('item.evidence', item.evidence);
            }
          });
          that.orderList = list;
          that.total = res.data.result.data.dataCount;
          if (this.form.handleStatus == 0) {
            this.waitHandle = res.data.result.data.dataCount
          }
          if (this.form.handleStatus == 2) {
            this.alreadyHandle = res.data.result.data.dataCount
          }
          if (this.form.handleStatus == 4) {
            this.alreadyRefuse = res.data.result.data.dataCount
          }
          if (this.form.handleStatus == -1 && this.form.IsNotAuditFor24 == true) {
            this.overTime = res.data.result.data.dataCount
          }
          that.refundVisible = false;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    handlePicker(e) {
      this.form.applyTimeStart = e[0];
      this.form.applyTimeEnd = e[1];
    },
    callFunction(item) {
      this[item.Func](item);
    },
    callFunctionRow(item, index, row) {
      this[item.Func](item, index, row);
    },
    handleCurrentChange(val) {
      this.form.pageIndex = val;
      this.getAfterSaleOrderList();
    },
    handleSizeChange(e) {
      this.form.pageSize = e;
      this.getAfterSaleOrderList();
    },
    onSubmit() {
      this.form.pageIndex = 1;
      this.getAfterSaleOrderList();
    },
    onEmpty() {
      this.orderStatusIsTrue = false;
      this.orderStatus = 0
      this.form = {
        keyWord: '',
        pageIndex: 1,
        pageSize: 10,
        type: 4,
        isNotAuditFor24: null,
        PurchaseSaleStatus: -1,
        handleStatus: 0,
        RefundStatus: -1,
        OrderNo: null,
        ApplyUser: null,
        SupReturnPayStatus: -1,
        FinanceStatus: -1,
        applyTimeStart: null,
        applyTimeEnd: null,
      };
      this.valueTime = [];
      this.getAfterSaleOrderList();
    },
    handleExp() {
      let that = this;
      afterExportList(that.form).then((res) => {
        if (res.data.success) {
          that.$message.success("操作成功，请点击下载中心查看下载结果");
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    handleDetail(row) {
      console.log('row', row);
      // this.$router.push(`/AfterSalesService/AfterSaleList/Detail?afterSaleOrderId=${row.id}`)
      this.$router.push(`/AfterSalesService/AfterSaleList/Detail?afterSaleOrderId=${row.id}`)
      // this.$router.push(`/Order/AfterSales/AfterSalesDetail?id=${row.Id}`);
    },
    handleClose() {
      this.showInfoVisible = false;
    },
    handleShowRefundInfo(row) {
      this.showInfoVisible = true;
      this.showRefundInfo = row;
    },
    //获取省
    getProvinceList() {
      let that = this;
      areaList({ areaLevel: 1 }).then((res) => {
        that.provinceList = res.data.response.data;
      });
    },
    //获取市
    getCityList(id) {
      let that = this;
      let params = {
        areaLevel: 2,
        parentId: id ? id : that.provinceId,
      };
      areaList(params).then((res) => {
        that.cityList = res.data.response.data;
      });
    },
    //获取区
    getAreaList(id) {
      let that = this;
      let params = {
        areaLevel: 3,
        parentId: id ? id : that.cityId,
      };
      areaList(params).then((res) => {
        that.areaList = res.data.response.data;
      });
    },
    //获取街道
    getStreetList(id) {
      let that = this;
      let params = {
        areaLevel: 4,
        parentId: id ? id : that.countyId,
      };
      areaList(params).then((res) => {
        that.streetList = res.data.response.data;
      });
    },
    //选择省市区
    handleProvince(e) {
      let that = this;
      that.provinceName = e.AreaName;
      that.cityName = null;
      that.countyName = null;
      that.townName = null;
      that.provinceId = e.Id;
      that.cityId = null;
      that.countyId = null;
      that.townId = null;
      that.getCityList(e.Id);
    },
    handleCity(e) {
      let that = this;
      that.cityName = e.AreaName;
      that.countyName = null;
      that.townName = null;
      that.cityId = e.Id;
      that.countyId = null;
      that.townId = null;
      that.getAreaList(e.Id);
    },
    handleArea(e) {
      let that = this;
      that.countyName = e.AreaName;
      that.townName = null;
      that.countyId = e.Id;
      that.townId = null;
      that.getStreetList(e.Id);
    },
    handleStreet(e) {
      let that = this;
      that.townName = e.AreaName;
      that.townId = e.Id;
    },
  },
  created() {
    this.getQiniuToken()
    let that = this;
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    var buttonList = getButtonList(this.$route.path, routers);
    const toolBarButtonList = buttonList.filter((item) => {
      return item.buttonShow === 10;
    });
    this.buttonList_toolBar = toolBarButtonList;
    console.log('buttonList', buttonList)
    buttonList.forEach((item) => {
      if (item.buttonFunc === "auxAftersale") {
        this.isAuxAftersale = true;
      }
      // 苏宁有货售后按钮组
      if (item.buttonFunc === "suningAftersale") {
        this.isSuningAftersale = true;
      }
      if (item.buttonFunc === "suningAftersaleApply") {
        this.isSuningAftersaleApply = true;
      }
      if (item.buttonFunc === "suningAftersaleCancl") {
        this.isSuningAftersaleCancl = true;
      }
      if (item.buttonFunc === "suningAftersaleSubmitLogistics") {
        this.isSuningAftersaleSubmitLogistics = true;
      }
      if (item.buttonFunc === "suningAftersaleChangeConfirmReceive") {
        this.isSuningAftersaleChangeConfirmReceive = true;
      }

      if (item.buttonFunc === "groupRefund") {
        this.canRefund = true;
      }
      if (item.buttonFunc === "passBtn") {
        this.isShowPass = true;
      }
      if (item.buttonFunc === "deductMemberRebate") {
        this.showDeductMemberRebateBtn = true;
      }
      if (item.buttonFunc === "refuseBtn") {
        this.isShowRefuse = true;
      }
      if (item.buttonFunc === "submitApproval") {
        this.isShowApproval = true;
      }
      if (item.buttonFunc === "cancelBtn") {
        this.isShowCancel = true;
      }
      if (item.buttonFunc === "allowDeductMemberRebateAmount") {
        this.allowDeductMemberRebateAmount = true;
      }
      if (item.buttonFunc === "checkBill") {
        this.isCheckBill = true;
      }
      if (item.buttonFunc === "remarkDetail") {
        this.remarkShow = true;
      }
    });
  },
};
</script>

<style scoped>
.aftersales_main1 {
  padding: 0 20px 20px 20px;
}

.el-input {
  width: 240px;
}

.el-textarea {
  width: 240px;
}

.logStyle {
  color: #409eff;
  cursor: pointer;
}

.item-sup {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.item-sup-l {
  margin-right: 6px;
}

.btm {
  margin-bottom: 10px;
}

.mar-r {
  margin-right: 20px;
}

.img-box {
  display: block;
  text-align: center;
}

.img-box .el_upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 150px;
  height: 150px;
}

.img-box .el_upload:hover {
  border-color: #409eff;
}

.img-box .el_upload:hover .mask {
  opacity: 1;
}

.img-box .mask {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  line-height: 150px;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
}

.img-box .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px !important;
  text-align: center;
}

.img-box .avatar {
  width: 150px;
  height: 150px;
}

.pic-info {
  width: 80px;
  height: 80px;
  margin: 5px;
  cursor: pointer;
}

.img_box {
  width: 80px;
  height: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  float: left;
  position: relative;
  margin-right: 10px;
}

.img_box img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.bg_box {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0;
}

.bg_box:hover {
  opacity: 1;
}

.del_box {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
}

.del_box img {
  height: 100%;
  width: 100%;
}

.el_upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.el-upload img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
</style>
<style>
.buyStyle {
  padding: 0 !important;
}

.buyStyle .cell {
  padding: 0 !important;
}

.highlighted {
  background: #f0e68c !important;
}

.aftersales_main1 .el-table__body tr.hover-row>td {
  background-color: #f0e68c !important;
}

.aftersales_main1 .el-table__body tr:hover>td {
  background-color: #f0e68c !important;
}

.profile_img_box {
  width: 120px;
  height: 120px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  position: relative;
  margin-right: 10px;
}

.profile_img_box img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.del_box {
  position: absolute;
  top: -15px;
  right: -10px;
  width: 20px;
  height: 20px;
}

.del_box img {
  height: 100%;
  width: 100%;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 24px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.item {
  margin-top: 10px;
  margin-right: 40px;
}

/deep/ .selected1 {
  background-color: #ecf5ff !important;
  color: #409eff;
}

.tab-box {
  font-size: 18px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #333333;
  padding-top: 10px;
}

.tab-item {
  margin: 0 16px;
  cursor: pointer;
  position: relative;
}

.tag {
  position: absolute;
  top: 0;
  right: 10px;
  transform: translateY(-50%) translateX(100%);
  background-color: #F56C6C;
  border-radius: 10px;
  color: #FFF;
  display: inline-block;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #FFF;
}

.activeTab {
  font-size: 22px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3b6ffa;
  position: relative;
}

.activeTab:after {
  content: "";
  width: 25px;
  height: 2px;
  background: #3b6ffa;
  border-radius: 2px;
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
}

.img_box1 {
  width: 120px;
  height: 120px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  position: relative;
  margin-right: 10px;
}

.img_box1 img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.del_box {
  position: absolute;
  top: -15px;
  right: -10px;
  width: 20px;
  height: 20px;
}

.del_box img {
  height: 100%;
  width: 100%;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 24px;
  color: #8c939d;
  width: 120px !important;
  height: 120px !important;
  line-height: 120px !important;
  text-align: center;
}
</style>
